msgid ""
msgstr ""
"POT-Creation-Date: 2025-01-07 14:43+0300\n"
"MIME-Version: 1.0\n"
"Content-Type: text/plain; charset=utf-8\n"
"Content-Transfer-Encoding: 8bit\n"
"X-Generator: @lingui/cli\n"
"Language: en\n"
"Project-Id-Version: \n"
"Report-Msgid-Bugs-To: \n"
"PO-Revision-Date: \n"
"Last-Translator: \n"
"Language-Team: \n"
"Plural-Forms: \n"

#. js-lingui-explicit-id
#: src/utils/validation.js:5
#: src/utils/validation.js:13
msgid "validation:phone"
msgstr "validation:phone"

#. js-lingui-explicit-id
#: src/utils/validation.js:8
#: src/utils/validation.js:16
msgid "validation:phoneLength"
msgstr "validation:phone length"

#. js-lingui-explicit-id
#: src/utils/validation.js:23
#: src/utils/valid.ts:21
#: src/utils/i18n-legacy.ts:69
#: src/containers/Users/NewUser.tsx:40
msgid "validation:required"
msgstr "validation:required"

#. js-lingui-explicit-id
#: src/utils/validation.js:27
#: src/utils/valid.ts:16
msgid "validation:no_spaces"
msgstr "validation:no spaces"

#. js-lingui-explicit-id
#: src/utils/validation.js:38
msgid "validation:one_lathin_lowercase_letter"
msgstr "validation:one Latin lowercase letter"

#. js-lingui-explicit-id
#: src/utils/validation.js:39
msgid "validation:one_lathin_uppercase_letter"
msgstr "validation:one Latin uppercase letter"

#. js-lingui-explicit-id
#: src/utils/validation.js:40
msgid "validation:one_digit"
msgstr "validation:one digit"

#. js-lingui-explicit-id
#: src/utils/validation.js:41
msgid "validation:more_than_8_length"
msgstr "validation:more than 8 length"

#. js-lingui-explicit-id
#: src/utils/validation.js:43
msgid "validation:password_must"
msgstr "validation:password must"

#. js-lingui-explicit-id
#: src/utils/valid.ts:11
msgid "validation:only_lathin_alphanumeric"
msgstr "validation:only Latin alphanumeric"

#. js-lingui-explicit-id
#: src/utils/i18n-legacy.ts:68
msgid "validation:invalid"
msgstr "validation:invalid"

#. js-lingui-explicit-id
#: src/utils/i18n-legacy.ts:70
msgid "validation:notType"
msgstr "validation:not type"

#. js-lingui-explicit-id
#: src/utils/i18n-legacy.ts:73
msgid "validation:min"
msgstr "validation:min"

#. js-lingui-explicit-id
#: src/utils/i18n-legacy.ts:74
msgid "validation:max"
msgstr "validation:max"

#. js-lingui-explicit-id
#: src/utils/i18n-legacy.ts:75
msgid "validation:moreThan"
msgstr "validation:more than"

#. js-lingui-explicit-id
#: src/utils/i18n-legacy.ts:76
msgid "validation:lessThan"
msgstr "validation:less than"

#. js-lingui-explicit-id
#: src/utils/i18n-legacy.ts:79
msgid "validation:length"
msgstr "validation:length"

#. js-lingui-explicit-id
#: src/utils/error.ts:17
msgid "operation-error"
msgstr "operation error"

#. js-lingui-explicit-id
#: src/utils/cartridge.ts:20
msgid "ui:units.volume"
msgstr "ui:units.volume"

#. js-lingui-explicit-id
#: src/utils/cartridge.ts:22
msgid "ui:units.hours"
msgstr "ui:units.hours"

#. js-lingui-explicit-id
#: src/errors/userErrors.ts:9
msgid "errors:incorrect_login_or_password"
msgstr "errors:incorrect login or password"

#. js-lingui-explicit-id
#: src/errors/userErrors.ts:17
#: src/errors/userErrors.ts:23
msgid "errors:password_change_required"
msgstr "errors:password change required"

#. js-lingui-explicit-id
#: src/errors/userErrors.ts:29
msgid "errors:incorrect_confirmation_code"
msgstr "errors:incorrect confirmation code"

#. js-lingui-explicit-id
#: src/errors/userErrors.ts:35
msgid "errors:user_blocked"
msgstr "errors:user blocked"

#. js-lingui-explicit-id
#: src/errors/baseErrors.js:7
msgid "errors:limit_reached"
msgstr "errors:limit reached"

#. js-lingui-explicit-id
#: src/containers/Terminals/NewDevice/DeviceBaseFields.tsx:36
msgid "validation:incorrect_device_key"
msgstr "validation:incorrect device key"

#. js-lingui-explicit-id
#: src/containers/Profile/EditProfile.tsx:23
msgid "validation:email"
msgstr "validation:email"

#. js-lingui-explicit-id
#: src/containers/Profile/ChangePassword.tsx:20
msgid "login:message.password_mismatch"
msgstr "login:message.password mismatch"

#. js-lingui-explicit-id
#: src/containers/DeviceList/columns/waterPlusColumns.tsx:46
msgid "ui:units.liters"
msgstr "ui:units.liters"

#. js-lingui-explicit-id
#: src/components/TerminalState.tsx:37
msgid "ui:yes"
msgstr "ui:yes"

#. js-lingui-explicit-id
#: src/components/TerminalState.tsx:37
msgid "ui:no"
msgstr "ui:no"

#. js-lingui-explicit-id
#: src/components/CartridgeValue/utils.ts:9
msgid "cartridges:step.OptionalMineralizer"
msgstr "cartridges:step.OptionalMineralizer"

#: src/containers/OraclePage/ComputeTab/utils.ts:247
msgid ""
"\n"
"\n"
"Детальный расчёт доходов (выручка):"
msgstr ""
"\n"
"\n"
"Detailed income calculation (revenue):"

#: src/containers/OraclePage/ComputeTab/utils.ts:277
msgid ""
"\n"
"\n"
"Детальный расчёт расходов:"
msgstr ""
"\n"
"\n"
"Detailed expense calculation:"

#: src/containers/OraclePage/ComputeTab/utils.ts:328
msgid ""
"\n"
"Аренда:"
msgstr ""
"\n"
"Rent:"

#: src/containers/OraclePage/ComputeTab/utils.ts:335
msgid ""
"\n"
"Вода:"
msgstr ""
"\n"
"Water:"

#: src/containers/OraclePage/ComputeTab/utils.ts:266
msgid ""
"\n"
"Доход от рекламы:"
msgstr ""
"\n"
"Advertising income:"

#: src/containers/OraclePage/ComputeTab/utils.ts:362
msgid ""
"\n"
"Мониторинг:"
msgstr ""
"\n"
"Monitoring:"

#: src/containers/OraclePage/ComputeTab/utils.ts:464
msgid ""
"\n"
"Налогообложение:"
msgstr ""
"\n"
"Taxation:"

#: src/containers/OraclePage/ComputeTab/utils.ts:459
msgid ""
"\n"
"Обслуживание кредита:"
msgstr ""
"\n"
"Credit maintenance:"

#: src/containers/OraclePage/ComputeTab/utils.ts:422
msgid ""
"\n"
"Пересчёт монет:"
msgstr ""
"\n"
"Coin recalculation:"

#: src/containers/OraclePage/ComputeTab/utils.ts:357
msgid ""
"\n"
"Персонал:"
msgstr ""
"\n"
"Personnel:"

#: src/containers/OraclePage/ComputeTab/utils.ts:263
msgid ""
"\n"
"Продажи:"
msgstr ""
"\n"
"Sales:"

#: src/containers/OraclePage/ComputeTab/utils.ts:271
msgid ""
"\n"
"Прочие доходы:"
msgstr ""
"\n"
"Other income:"

#: src/containers/OraclePage/ComputeTab/utils.ts:412
msgid ""
"\n"
"Разовые расходы за период:"
msgstr ""
"\n"
"One-time expenses for the period:"

#: src/containers/OraclePage/ComputeTab/utils.ts:367
msgid ""
"\n"
"Фильтр 1 ступень:"
msgstr ""
"\n"
"Filter 1 stage:"

#: src/containers/OraclePage/ComputeTab/utils.ts:372
msgid ""
"\n"
"Фильтр 2 ступень:"
msgstr ""
"\n"
"Filter 2 stage:"

#: src/containers/OraclePage/ComputeTab/utils.ts:377
msgid ""
"\n"
"Фильтр 3 ступень:"
msgstr ""
"\n"
"Filter 3 stage:"

#: src/containers/OraclePage/ComputeTab/utils.ts:382
msgid ""
"\n"
"Фильтр 4 ступень:"
msgstr ""
"\n"
"Filter 4 stage:"

#: src/containers/OraclePage/ComputeTab/utils.ts:387
msgid ""
"\n"
"Фильтр 5 ступень:"
msgstr ""
"\n"
"Filter 5 stage:"

#: src/containers/OraclePage/ComputeTab/utils.ts:392
msgid ""
"\n"
"Фильтр 6 ступень:"
msgstr ""
"\n"
"Filter 6 stage:"

#: src/containers/OraclePage/ComputeTab/utils.ts:397
msgid ""
"\n"
"Фильтр 7 ступень:"
msgstr ""
"\n"
"Filter 7 stage:"

#: src/containers/OraclePage/ComputeTab/utils.ts:402
msgid ""
"\n"
"Фильтр 8 ступень:"
msgstr ""
"\n"
"Filter 8 stage:"

#: src/containers/OraclePage/ComputeTab/utils.ts:407
msgid ""
"\n"
"Фильтр 9 ступень:"
msgstr ""
"\n"
"Filter 9 stage:"

#: src/containers/OraclePage/ComputeTab/utils.ts:439
msgid ""
"\n"
"Эквайринг:"
msgstr ""
"\n"
"Acquiring:"

#: src/containers/OraclePage/ComputeTab/utils.ts:349
msgid ""
"\n"
"Электричество:"
msgstr ""
"\n"
"Electricity:"

#. placeholder {0}: formatMoney(sales.Exchange || 0, currency)
#: src/containers/OraclePage/ComputeTab/utils.ts:178
msgid "- {0} [сдача]"
msgstr "- {0} [change]"

#. placeholder {0}: formatMoney(data.sales.Coins || 0, currency)
#. placeholder {1}: formatMoney( data.sales.Exchange || 0, currency )
#. placeholder {2}: formatMoney(diff, currency)
#. placeholder {3}: finStatementsForPeriod.CoinConversionFeeInPercent
#: src/containers/OraclePage/ComputeTab/utils.ts:425
msgid "[{0} монет - {1} сдачи = {2} монет, {3}% затраты на пересчёт монет]"
msgstr "[{0} coins - {1} change = {2} coins, {3}% cost for coin recalculation]"

#. placeholder {0}: formatMoney( data.sales.Bankcard || 0, currency )
#. placeholder {1}: formatMoney( data.sales.MobileApp || 0, currency )
#. placeholder {2}: formatMoney(acquiringSum, currency)
#. placeholder {3}: finStatementsForPeriod.AcquiringFeeInPercent
#: src/containers/OraclePage/ComputeTab/utils.ts:442
msgid "[{0} оплат по банк. карте + {1} оплат по приложению = {2}, {3}% затраты на эквайринг]"
msgstr "[{0} payments by bank card + {1} payments by app = {2}, {3}% cost for acquiring]"

#. placeholder {0}: formatMoney( data.income, currency )
#. placeholder {1}: formatMoney( data.intermediateValues?.expensesTotalBeforeTaxes || 0, currency )
#: src/containers/OraclePage/ComputeTab/utils.ts:482
msgid "[выбраны \"{type}\", доходы = {0}, затраты до вычета налогов = {1}]"
msgstr "[selected \"{type}\", income = {0}, expenses before taxes = {1}]"

#: src/containers/OraclePage/ComputeTab/utils.ts:67
msgid "[Если нулевые значения кВт, возможно на терминале не подключена телеметрия]"
msgstr "[If the kWt values are zero, telemetry may not be connected on the terminal]"

#. placeholder {0}: finStatementsForPeriod.WaterConversionRatio
#: src/containers/OraclePage/ComputeTab/utils.ts:129
msgid "[Продано {litres} литров = {waterAfterConversionM3} м3, коэффициент конвертации воды = {0}, вода на входе до фильтрации = {waterBeforeConversionM3} м3]"
msgstr "[Sold {litres} liters = {waterAfterConversionM3} m3, water conversion ratio = {0}, water input before filtration = {waterBeforeConversionM3} m3]"

#. placeholder {0}: months.toFixed(2)
#: src/containers/OraclePage/ComputeTab/utils.ts:31
msgid "{0, plural, one {# месяц} two {# месяца} few {# месяцев} other {# месяцев}}"
msgstr "{0, plural, one {# month} other {# months}}"

#: src/containers/Migrations/Migrations.tsx:3829
msgid "{megabytes} МБ"
msgstr "{megabytes} MB"

#: src/containers/Terminals/Terminal/DeviceState/RemainWater/RemainWater.tsx:38
msgid "{percentValue} - значение вычислено на основе продаж"
msgstr "{percentValue} - the value is calculated based on sales"

#: src/containers/Migrations/Migrations.tsx:2611
msgid "{scopeLabel}: {migratedCount} аппаратов"
msgstr "{scopeLabel}: {migratedCount} devices"

#: src/containers/Dashboard/BillingStats/columns.tsx:28
msgid "{value} из {Total}<0/> {percentFormatted}"
msgstr "{value} from {Total}<0/> {percentFormatted}"

#: src/locales/constants.ts:40
msgid "°"
msgstr "°"

#: src/locales/constants.ts:38
msgid "°C"
msgstr "°C"

#. placeholder {0}: formatMoney(data.intermediateValues?.expensesRental, currency)
#: src/containers/OraclePage/ComputeTab/utils.ts:280
msgid "+ {0} [аренда]"
msgstr "+ {0} [rent]"

#. placeholder {0}: formatMoney(bankAndTaxation, currency)
#: src/containers/OraclePage/ComputeTab/utils.ts:323
msgid "+ {0} [банк и налогообложение]"
msgstr "+ {0} [bank and taxation]"

#. placeholder {0}: formatMoney(sales.Bankcard || 0, currency)
#: src/containers/OraclePage/ComputeTab/utils.ts:174
msgid "+ {0} [банк. карта]"
msgstr "+ {0} [bank card]"

#. placeholder {0}: formatMoney(sales.Banknotes || 0, currency)
#: src/containers/OraclePage/ComputeTab/utils.ts:172
msgid "+ {0} [банкноты]"
msgstr "+ {0} [banknotes]"

#. placeholder {0}: formatMoney(waterTotalExpenses, currency)
#: src/containers/OraclePage/ComputeTab/utils.ts:287
msgid "+ {0} [вода]"
msgstr "+ {0} [water]"

#. placeholder {0}: formatMoney( data.intermediateValues?.incomeAdvertising || 0, currency )
#: src/containers/OraclePage/ComputeTab/utils.ts:250
msgid "+ {0} [доходы от рекламы]"
msgstr "+ {0} [advertising income]"

#. placeholder {0}: formatMoney(sales.MobileApp || 0, currency)
#: src/containers/OraclePage/ComputeTab/utils.ts:176
msgid "+ {0} [моб. приложение]"
msgstr "+ {0} [mobile app]"

#. placeholder {0}: formatMoney(sales.Coins || 0, currency)
#: src/containers/OraclePage/ComputeTab/utils.ts:173
msgid "+ {0} [монеты]"
msgstr "+ {0} [coins]"

#. placeholder {0}: formatMoney(pointMaintenance, currency)
#: src/containers/OraclePage/ComputeTab/utils.ts:298
msgid "+ {0} [обслуживание точки]"
msgstr "+ {0} [point maintenance]"

#. placeholder {0}: formatMoney(data.sales.Amount || 0, currency)
#: src/containers/OraclePage/ComputeTab/utils.ts:248
msgid "+ {0} [продажи]"
msgstr "+ {0} [sales]"

#. placeholder {0}: formatMoney( data.intermediateValues?.incomeOtherSources || 0, currency )
#: src/containers/OraclePage/ComputeTab/utils.ts:256
msgid "+ {0} [прочие доходы]"
msgstr "+ {0} [other income]"

#. placeholder {0}: formatMoney( data.intermediateValues?.expensesOneTime || 0, currency )
#: src/containers/OraclePage/ComputeTab/utils.ts:312
msgid "+ {0} [разовые расходы]"
msgstr "+ {0} [one-time expenses]"

#. placeholder {0}: formatMoney(cartridges, currency)
#: src/containers/OraclePage/ComputeTab/utils.ts:310
msgid "+ {0} [фильтры]"
msgstr "+ {0} [cartridges]"

#. placeholder {0}: formatMoney( data.intermediateValues?.expensesElectricityPerKwH || 0, currency )
#: src/containers/OraclePage/ComputeTab/utils.ts:289
msgid "+ {0} [электричество]"
msgstr "+ {0} [electricity]"

#: src/containers/OraclePage/ComputeTab/utils.ts:78
msgid "+ {money} [{kwH} кВт c {fromStr} по {toStr}, {moneyPerWat} за кВт]"
msgstr "+ {money} [{kwH} kWt from {fromStr} to {toStr}, {moneyPerWat} per kWt]"

#: src/containers/OraclePage/ComputeTab/utils.ts:54
msgid "+ {money} [{month} c {fromStr} по {toStr}, {moneyPerMonth} в месяц]"
msgstr "+ {money} [{month} from {fromStr} to {toStr}, {moneyPerMonth} per month]"

#: src/containers/OraclePage/ComputeTab/utils.ts:157
msgid "+ {negativeImpactCostPerM3} [Негативное воздействие, {negativeImpactCost} за м3]"
msgstr "+ {negativeImpactCostPerM3} [Negative impact, {negativeImpactCost} per m3]"

#: src/containers/OraclePage/ComputeTab/utils.ts:146
msgid "+ {wasteWaterCostPerM3} [Водоотведение, {wasteWaterCost} за м3]"
msgstr "+ {wasteWaterCostPerM3} [Wastewater disposal, {wasteWaterCost} per m3]"

#: src/containers/OraclePage/ComputeTab/utils.ts:136
msgid "+ {waterCostPerM3} [ХВС, {waterCost} за м3]"
msgstr "+ {waterCostPerM3} [CWS, {waterCost} per m3]"

#: src/containers/Terminals/Terminal/TerminalTitle.tsx:90
msgid "<0> Аппарат <1>{deviceAddress}</1> будет удален безвозвратно.</0><2>Продолжить?</2>"
msgstr "<0> The device <1>{deviceAddress}</1> will be permanently deleted.</0><2>Continue?</2>"

#. placeholder {0}: SUPPORT_LINKS.TG
#. placeholder {1}: SUPPORT_LINKS.Tell
#: src/containers/Login/LoginForm.tsx:120
msgid "<0>Для получения аккаунта в системе GSM мониторинга вам необходимо обратиться в службу технической поддержки по следующим каналам:</0><1><2>{0}</2></1><3><4>{1}</4></3><5>Техническая поддержка работает ежедневно, с 7:00 до 21:00 по Московскому времени. Оформление доступа в личный кабинет происходит <6>ТОЛЬКО</6> через переписку!</5>"
msgstr "<0>To get an account in the GSM monitoring system, you need to contact the technical support service through the following channels:</0><1><2>{0}</2></1><3><4>{1}</4></3><5>Technical support is available daily, from 7:00 to 21:00 Moscow time. Registration of access to the personal account takes place <6>ONLY</6> through correspondence!</5>"

#: src/containers/Services/Recharge.tsx:118
msgid "<0>Нажимая на кнопку <1>Пополнить</1>, вы соглашаетесь с условиями <2>Оферты</2></0><3>Если вам необходимы отчетные документы по оказанным услугам (акт оказанных услуг и счет-фактура), просим оплату проводить платежным поручением с расчетного счета юридического лица, на указанные ниже реквизиты:<4>ИП Вяткин Вячеслав Владимирович ИНН 591600372797 Р/с <5/>40802810049770036699 в ВОЛГО-ВЯТСКИЙ БАНК ПАО СБЕРБАНК БИК<6/>042202603, к/с 30101810900000000603 Назначение платежа: \"4GSM Оплата информационного взаимодействия\"<7/></4><8>Для корректного зачисления платежа необходимо в профиле кабинета заполнить поле \"Налоговый идентификатор\"</8>При оплате банковской картой на сайте отчетные документы на реквизиты юридического лица предоставляться не будут.</3><9>Минимальная сумма платежа - {minPaymentSum}₽<10/>Максимальная сумма платежа - {maxPaymentSum}₽</9>"
msgstr "<0>By clicking the <1>Top up</1> button, you agree to the terms of the <2>Offer</2></0><3>If you need reporting documents for the services rendered (certificate of services rendered and invoice), please make the payment by payment order from the current account of a legal entity, to the details specified below:<4>ИП Вяткин Вячеслав Владимирович ИНН 591600372797 Р/с <5/>40802810049770036699 в ВОЛГО-ВЯТСКИЙ БАНК ПАО СБЕРБАНК БИК<6/>042202603, к/с 30101810900000000603 Назначение платежа: \"4GSM Оплата информационного взаимодействия\"<7/></4><8>For correct payment crediting, it is necessary to fill in the account profile field \"BIN\"</8>When paying by bank card on the website, reporting documents for the details of a legal entity will not be provided.</3><9>Minimum payment amount - {minPaymentSum}₽<10/>Maximum payment amount - {maxPaymentSum}₽</9>"

#: src/containers/Services/Recharge.tsx:178
msgid "<0>Обращаем ваше внимание, что денежные средства с вашей карты будут списаны в {currency}.  Сумма к списанию составляет <1>{formattedAmount}</1></0><2>Уважаемые клиенты компании \"Живая вода\".<3/>Хотим Вас проинформировать, что в связи с изменениями условий в одностороннем порядке банком партнером, с 01.08.2023 минимально возможная сумма для оплаты услуг GSM мониторинга составит в эквиваленте местной валюты 13 $<4/>Увеличение минимальной суммы платежа в 13 $ позволит Вам избежать комиссии банка в размере 1 $ с каждой оплаты.<5/>Наша Компания приложит все усилия над поиском альтернативных вариантов приема платежей по картам, эмитированным банками не резидентами РФ, в привычном Вам формате<6/></2>"
msgstr "<0>Please note that funds will be debited from your card in {currency}. The amount to be debited is <1>{formattedAmount}</1></0><2>Dear customers of the company \"Zhivaya Voda\".<3/>We would like to inform you that due to unilateral changes in the terms and conditions by the partner bank, from 01.08.2023 the minimum possible amount for payment for GSM monitoring services will be $13 in local currency equivalent<4/>Increasing the minimum payment amount to $13 will allow you to avoid a bank commission of $1 for each payment.<5/>Our Company will make every effort to find alternative options for accepting payments from cards issued by banks that are not residents of the Russian Federation, in the format you are accustomed to<6/></2>"

#: src/containers/Terminals/NewDevice/CreateNotAvailable.tsx:6
msgid "<0>С 30.05.202 для России и 01.10.2022 для других стран, операции, связанные добавлением оборудования будут доступны только через сотрудников технической поддержки.</0><1>С технической поддержкой можно связаться:<2><3>телеграмм <4>@ALIVEWATERNEWBOT</4></3></2></1><5>Для добавления оборудования вам необходимо указать следующую информацию:<6><7>логин к которому добавляется оборудование и наименование компании (так, как это указано в мониторинге)</7><8>IMEI аппарата</8><9>тип оборудования (доочистка или привозная)</9><10>номер симкарты, установленный в аппарате в формате +код страны</10><11>номер телефона (для России +7хххххххххх)</11><12>часовой пояс аппарата</12><13>валюта аппарата </13><14>телефон технической поддержки в формате + код страны</14><15>номер телефона (для России +7хххххххххх)</15><16>адрес установки аппарата в формате город, улица номер дома (строения)</16><17> стоимость воды за 1 л за наличные</17><18>стоимость воды за 1 л по IC карте</18></6></5>"
msgstr "<0>From 30.05.202 for Russia and 01.10.2022 for other countries, operations related to adding equipment will be available only through technical support staff.</0><1>You can contact technical support:<2><3>Telegram <4>@ALIVEWATERNEWBOT</4></3></2></1><5>To add equipment, you need to provide the following information:<6><7>Login to which the equipment is added and the company name (as indicated in the monitoring)</7><8>IMEI of the device</8><9>Type of equipment (post-treatment or delivery)</9><10>SIM card number installed in the device in the format +country code</10><11>Phone number (for Russia +7xxx)</11><12>Time zone of the device</12><13>Currency of the device</13><14>Technical support phone number in the format +country code</14><15>Phone number (for Russia +7xxx)</15><16>Installation address of the device in the format city, street, house number (building)</16><17>Cost of water per 1 liter for cash</17><18>Cost of water per 1 liter by IC card</18></6></5>"

#: src/containers/Terminals/Terminal/TerminalTitle.tsx:100
msgid "<0>С 30.05.2022 операции, связанные удалением оборудования будут доступны только через сотрудников технической поддержки.</0><1>С технической поддержкой можно связаться:<2><3>телеграмм <4>@ALIVEWATERNEWBOT</4></3></2></1><5>Для удаления аппарата необходимо указать следующую информацию:<6><7>логин у которого удаляется аппарат</7><8>наименование компании (так, как это указано в мониторинге)</8><9>IMEI удаляемого аппарата</9><10>причина удаления аппарата</10></6></5>"
msgstr "<0>From 30.05.2022, operations related to removing equipment will be available only through technical support staff.</0><1>You can contact technical support:<2><3>Telegram <4>@ALIVEWATERNEWBOT</4></3></2></1><5>To remove a device, you need to provide the following information:<6><7>Login from which the device is removed</7><8>Company name (as indicated in the monitoring)</8><9>IMEI of the device being removed</9><10>Reason for removing the device</10></6></5>"

#: src/containers/LowBalanceNotification/LowBalanceNotification.tsx:45
msgid "<0>Уважаемые пользователи GSM мониторинга!</0><1>Что бы избежать возможных сложностей при оплате услуг GSM мониторинга в начале месяца, настоятельно рекомендуем сделать очередной платеж за GSM мониторинг не позднее 25го числа текущего месяца.</1><2>Это позволит оперативно разобраться в проблеме, если она возникнет во время оплаты, и минимизировать время недоступности мониторинга для вас</2>"
msgstr "<0>Dear GSM monitoring users!</0><1>To avoid possible difficulties when paying for GSM monitoring services at the beginning of the month, we strongly recommend making the next GSM monitoring payment no later than the 25th of the current month.</1><2>This will make it possible to quickly resolve any issue if it occurs during payment, and minimize the monitoring downtime for you.</2>"

#: src/components/ServiceNotificationModal.tsx:40
msgid "<0>Что это означает простыми словами?</0><1><2>Доступ к мониторингу платный и составляет <3>200 руб</3> за один аппарат в месяц. Метод расчетов - авансовый. Списание средств с баланса будет происходить первого числа ежемесячно в размере 200 руб * число аппаратов, зарегистрированных в мониторинге на дату списания.</2></1><4>В случае, если средств на балансе не хватает на все оборудование, доступ к личному кабинету будет приостановлен до пополнения баланса. Все описанное выше распространяется на оборудование, зарегистрированное в мониторинге до 06.2021.</4><5><6>При регистрации нового оборудования на ваш баланс будет начислена сумма 200 руб на каждую единицу оборудования</6><7>Операции связанные с добавлением и удалением оборудования с 01.06.2022 будут производиться ТОЛЬКО через службу технической поддержки.</7><8>Возможность принимать платежи через приложение и/или через QR код так же становится платной. Оплата составляет 100 руб/мес. Данную услугу вы можете самостоятельно подключить/отключить в мониторинге.</8></5><9>Первое списание денежных средств с баланса произойдёт 01.07.2022. До этого момента настоятельно рекомендуем вам пополнить ваш баланс в личном кабинете.</9>"
msgstr "<0>What does this mean in simple terms?</0><1><2>Access to monitoring is paid and amounts to <3>200 rubles</3> per device per month. The payment method is upfront. Funds will be debited from the balance on the first day of the month in the amount of 200 rubles * the number of devices registered in monitoring on the date of write-off.</2></1><4>If the funds on the balance are not enough for all the equipment, access to the personal account will be suspended until the balance is replenished. All of the above applies to equipment registered in monitoring before 06.2021.</4><5><6>When registering new equipment, the amount of 200 rubles for each piece of equipment will be credited to your balance</6><7>Operations related to adding and removing equipment from 06/01/2022 will be performed ONLY through the technical support service.</7><8>The ability to accept payments through the app and/or through a QR code also becomes paid. The payment is 100 rubles/month. You can enable/disable this service yourself in monitoring.</8></5><9>The first debit of funds from the balance will occur on 07/01/2022. Until then, we strongly recommend that you top up your balance in your personal account.</9>"

#: src/containers/Terminals/EditDevice/BundleDeviceInfo.tsx:32
msgid "<0>Что это означает простыми словами?</0><1><2>У аппарата одна общая система водоподготовки и две камеры розлива, каждая из которых имеет свою плату управления. В системе мониторинга такой аппарат технически воспринимается как два отдельных устройства. Однако для удобства их данные иногда объединяются в одном интерфейсе.</2><3>Устройство с подключенной системой водоподготовки называют ГЛАВНЫМ, а второе, без собственной системы, — ВТОРИЧНЫМ.</3><4>Чтобы жизнь стала проще, изменения настроек платы управления главного устройства автоматически копирутся на вторичное. Но если нужно, настройки вторичного устройства можно скорректировать вручную.</4></1><5>Идея проста: Объединять такие аппараты в единое устройство там, где это удобно, и разделять их на два независимых элемента, когда это необходимо.</5>"
msgstr "<0>What does this mean in simple terms?</0><1><2>The device has one common water treatment system and two dispensing chambers, each with its own control board. In the monitoring system, such a device is technically perceived as two separate devices. However, for convenience, their data is sometimes combined in one interface.</2><3>The device with the connected water treatment system is called the MAIN device, and the second one, without its own system, is called the SECONDARY device.</3><4>To make life easier, changes to the control board settings of the main device are automatically copied to the secondary device. But if necessary, the settings of the secondary device can be adjusted manually.</4></1><5>The idea is simple: to combine such devices into a single device where it is convenient, and to separate them into two independent elements when necessary.</5>"

#: src/containers/Terminals/EditDevice/BundleDeviceAdmin.tsx:206
msgid "<0>Это вторичное устройство. Редактируйте его на странице главного:</0><1><2>Перейти к главному устройству</2></1>"
msgstr "<0>This is a secondary device. Edit it on the main device page:</0><1><2>Go to the main device</2></1>"

#: src/containers/Migrations/formatDuration.tsx:7
msgid "<1с"
msgstr "<1s"

#. placeholder {0}: formatMoney(acc, currency)
#. placeholder {0}: formatMoney(total, currency)
#. placeholder {0}: formatMoney(sales.Amount || 0, currency)
#: src/containers/OraclePage/ComputeTab/utils.ts:57
#: src/containers/OraclePage/ComputeTab/utils.ts:85
#: src/containers/OraclePage/ComputeTab/utils.ts:112
#: src/containers/OraclePage/ComputeTab/utils.ts:163
#: src/containers/OraclePage/ComputeTab/utils.ts:179
#: src/containers/OraclePage/ComputeTab/utils.ts:261
#: src/containers/OraclePage/ComputeTab/utils.ts:325
#: src/containers/OraclePage/ComputeTab/utils.ts:433
#: src/containers/OraclePage/ComputeTab/utils.ts:453
msgid "= {0}"
msgstr "= {0}"

#. placeholder {0}: formatMoney( data.intermediateValues?.expensesTax || 0, currency )
#: src/containers/OraclePage/ComputeTab/utils.ts:491
msgid "= {0} налог"
msgstr "= {0} tax"

#: src/containers/Terminals/EditDevice/AcidWashFields.tsx:33
msgid "100 мл"
msgstr "100 ml"

#: src/containers/Terminals/EditDevice/AcidWashFields.tsx:41
msgid "30 мл"
msgstr "30 ml"

#: src/containers/Terminals/Terminal/DeviceState/TerminalBoard.tsx:184
msgid "4x строчный"
msgstr "4x single-line"

#: src/containers/Terminals/Terminal/DeviceState/TerminalBoard.tsx:186
msgid "4x строчный и отображаются 10 доли"
msgstr "4x single-line and display 10 fractions"

#: src/containers/Terminals/EditDevice/AcidWashFields.tsx:37
msgid "50 мл"
msgstr "50 ml"

#: src/containers/Dashboard/AllMoney/utils.ts:42
msgid "App/Qr"
msgstr "App/Qr"

#: src/locales/constants.ts:37
msgid "c."
msgstr "s."

#: src/containers/Migrations/Migrations.tsx:2847
msgid "Consumer Lag Kafka"
msgstr "Kafka Consumer Lag"

#: src/config/menu.tsx:30
msgid "Dashboard"
msgstr "Dashboard"

#: src/locales/constants.ts:45
msgid "Email"
msgstr "Email"

#: src/containers/Migrations/Migrations.tsx:2888
msgid "EWMA стоимости страницы"
msgstr "Page cost EWMA"

#: src/locales/constants.ts:12
#: src/containers/Terminals/Terminal/DeviceState/TerminalSummary.tsx:67
#: src/containers/DeviceList/columns/desktop.tsx:62
msgid "IMEI"
msgstr "IMEI"

#: src/hooks/useTempreatureFormatter.ts:9
msgid "N/A"
msgstr "N/A"

#: src/containers/Migrations/Migrations.tsx:700
#: src/containers/Migrations/Migrations.tsx:992
msgid "Parquet, МБ (telemetry 6 мес., оценка)"
msgstr "Parquet, MB (6-month telemetry, estimate)"

#: src/containers/Migrations/Migrations.tsx:3228
msgid "Parquet, МБ (telemetry 6 мес., суммарная оценка)"
msgstr "Parquet, MB (6-month telemetry, total estimate)"

#: src/containers/Migrations/Migrations.tsx:676
#: src/containers/Migrations/Migrations.tsx:964
msgid "Parquet, МБ (всё, оценка)"
msgstr "Parquet, MB (all data, estimate)"

#: src/containers/Migrations/Migrations.tsx:3219
msgid "Parquet, МБ (всё, суммарная оценка)"
msgstr "Parquet, MB (all data, total estimate)"

#: src/containers/Migrations/Migrations.tsx:2801
msgid "Pod"
msgstr "Pod"

#: src/containers/SystemMaintenance/SystemMaintenance.tsx:86
msgid "Portal и worker вернутся к штатной обработке."
msgstr "Portal and workers will resume normal operation."

#: src/containers/Migrations/Migrations.tsx:706
#: src/containers/Migrations/Migrations.tsx:998
msgid "PostgreSQL, МБ (telemetry 6 мес., оценка)"
msgstr "PostgreSQL, MB (6-month telemetry, estimate)"

#: src/containers/Migrations/Migrations.tsx:3238
msgid "PostgreSQL, МБ (telemetry 6 мес., суммарная оценка)"
msgstr "PostgreSQL, MB (6-month telemetry, total estimate)"

#: src/containers/Migrations/Migrations.tsx:682
#: src/containers/Migrations/Migrations.tsx:972
msgid "PostgreSQL, МБ (всё, оценка)"
msgstr "PostgreSQL, MB (all data, estimate)"

#: src/containers/Migrations/Migrations.tsx:3223
msgid "PostgreSQL, МБ (всё, суммарная оценка)"
msgstr "PostgreSQL, MB (all data, total estimate)"

#: src/locales/constants.ts:34
#: src/containers/DeviceList/columns/mobile.tsx:91
msgid "ppm"
msgstr "ppm"

#: src/components/ConnectBot/ConnectBot.tsx:179
msgid "Telegram пользователь успешно отвязан"
msgstr "Telegram user successfully unlinked"

#: src/containers/Migrations/Migrations.tsx:694
#: src/containers/Migrations/Migrations.tsx:986
msgid "Telemetry mono за 6 месяцев"
msgstr "Telemetry mono for 6 months"

#: src/containers/Migrations/Migrations.tsx:688
#: src/containers/Migrations/Migrations.tsx:978
msgid "Telemetry за 6 месяцев"
msgstr "Telemetry for 6 months"

#: src/containers/Terminals/EditDevice/EditDeviceTabTitle.tsx:26
msgid "Wi-Fi"
msgstr "Wi-Fi"

#: src/containers/Migrations/Migrations.tsx:3180
msgid "Автообновление каждые 20 секунд"
msgstr "Auto-refresh every 20 seconds"

#: src/containers/Migrations/Migrations.tsx:2990
msgid "Автообновление каждые 5 секунд"
msgstr "Auto-refresh every 5 seconds"

#: src/locales/constants.ts:5
#: src/containers/Encash/useEncashColumns.tsx:78
#: src/containers/DeviceList/columns/base.tsx:35
msgid "Адрес"
msgstr "Address"

#: src/locales/constants.ts:4
msgid "Адрес установки аппарата"
msgstr "Address of the device installation"

#: src/containers/Terminals/EditDevice/EditDevice.tsx:128
msgid "Активация аппарата прошла успешно"
msgstr "Terminal activation was successful"

#: src/containers/Terminals/EditDevice/EditDevice.tsx:172
msgid "Активировать аппарат"
msgstr "Activate Terminal"

#: src/containers/Migrations/Migrations.tsx:3085
msgid "Активные COPY"
msgstr "Active COPY operations"

#: src/containers/Migrations/Migrations.tsx:2872
msgid "Активные Query"
msgstr "Active queries"

#: src/containers/Dashboard/Users/Users.tsx:75
msgid "Активные за последние 2 месяца"
msgstr "Active in the last 2 months"

#: src/containers/Dashboard/Users/Users.tsx:86
msgid "Активные за последние 2 месяца по группам"
msgstr "Active in the last 2 months by groups"

#: src/containers/Dashboard/Users/Users.tsx:57
msgid "Активных за последние 2 месяца"
msgstr "Number of active users in the last 2 months"

#: src/containers/Terminals/Terminal/DeviceState/TerminalFinState.tsx:61
msgid "Акция"
msgstr "Promo"

#: src/containers/Terminals/Terminal/Device.tsx:122
msgid "Аналитика"
msgstr "Analitycs"

#: src/features/deviceAlerts/i18n/translations.ts:8
msgid "Аппарат давно не выходил на связь. Возможно, с ним есть определенные проблемы"
msgstr "The device has not been communicating for a long time"

#: src/containers/Terminals/EditDevice/EditDevice.tsx:80
msgid "Аппарат обновлен"
msgstr "Updated device"

#: src/containers/Terminals/EditDevice/BundleDeviceInfo.tsx:26
msgid "Аппарат с двумя камерами розлива"
msgstr "Device with two dispensing chambers"

#: src/containers/Terminals/EditDevice/EditDevice.tsx:167
msgid "Аппарат требует активации службой технической поддержки"
msgstr "The terminal requires activation by tech support"

#: src/containers/Terminals/Terminal/TerminalTitle.tsx:76
msgid "Аппарат удален"
msgstr "The device has been deleted"

#: src/containers/Migrations/Migrations.tsx:3921
msgid "Аппаратов"
msgstr "Devices"

#: src/containers/Migrations/Migrations.tsx:3749
msgid "Аппаратов: {count}"
msgstr "Devices: {count}"

#: src/containers/Migrations/Migrations.tsx:929
#: src/containers/Migrations/Migrations.tsx:3490
#: src/containers/Dashboard/Dashboard.tsx:37
#: src/config/menu.tsx:54
#: src/components/Stats/UserDevices.tsx:85
msgid "Аппараты"
msgstr "Devices"

#: src/containers/Migrations/SystemMigrations.tsx:229
#: src/containers/Migrations/SystemMigrations.tsx:234
msgid "Архив"
msgstr "Archive"

#: src/containers/Terminals/Terminal/DeviceState/TerminalSummary.tsx:82
#: src/containers/Terminals/NewDevice/DeviceBaseFields.tsx:191
msgid "Архивная версия платформы"
msgstr "Archived platform version"

#: src/locales/constants.ts:36
msgid "атм"
msgstr "atm"

#: src/containers/Terminals/Terminal/Device.tsx:128
#: src/containers/DeviceList/constants.ts:27
msgid "Аудит"
msgstr "Audit"

#: src/containers/Terminals/Terminal/DeviceState/TerminalSummary.tsx:105
#: src/containers/Services/Services.tsx:204
#: src/containers/Services/BalanceHistory.tsx:45
msgid "Баланс"
msgstr "Balance"

#: src/containers/Terminals/EditDevice/WifiFields.tsx:47
msgid "Безопасность"
msgstr "Encryption"

#: src/containers/Terminals/EditDevice/MainboardFields/BottlerFields.tsx:20
msgid "Блокировка при открытой дверце"
msgstr "Locking when the door is open"

#: src/components/ConnectBot/ConnectMaxBot.tsx:48
msgid "Бот на пермской площадке @AW_cyberbot_new"
msgstr "Bot on the Perm site @AW_cyberbot_new"

#: src/components/ConnectBot/ConnectBot.tsx:49
msgid "Бот на пермской тестовой площадке @AwPermTestBot"
msgstr "Bot on the Perm test environment @AwPermTestBot"

#. placeholder {0}: DateTime.fromMillis(device?.DeviceState.UpdatedAt ?? 0).toFormat('t')
#. placeholder {1}: t('ui:units.liters_per_minute', { value })
#: src/containers/Terminals/Terminal/DeviceState/TerminalWaterPrepare.tsx:131
msgid "в {0} - {1}"
msgstr "in {0} - {1}"

#. placeholder {2}: DateTime.fromMillis(device?.DeviceState.UpdatedAt ?? 0).toFormat('t')
#. placeholder {3}: t('ui:units.liters_per_minute', { value })
#: src/containers/Terminals/Terminal/DeviceState/TerminalWaterPrepare.tsx:142
msgid "в {2} - {3}"
msgstr "in {2} - {3}"

#: src/features/deviceAlerts/i18n/translations.ts:12
msgid "В аппарате более 2 часов не было продаж. Возможно, с ним есть определенные проблемы"
msgstr "There were no sales in the device for more than 2 hours"

#: src/containers/Encash/useEncashColumns.tsx:88
msgid "В купюрах"
msgstr "In bills"

#: src/containers/Encash/useEncashColumns.tsx:94
msgid "В монетах"
msgstr "In coins"

#: src/containers/Users/UsersList.tsx:31
msgid "В сети"
msgstr "Online"

#: src/containers/Sales/SalesTotal.tsx:115
msgid "в том числе обогащенной воды <0>{otherWaterLitres} ({otherWaterLitersPercent})</0> на <1>{otherWaterAmount} ({otherWaterAmountPercent})</1>"
msgstr "the root is that the numbers are enriched in. <0>{otherWaterLitres} ({otherWaterLitersPercent})</0> by <1>{otherWaterAmount}({otherWaterAmountPercent})</1>"

#: src/locales/constants.ts:11
msgid "Валюта"
msgstr "Currency"

#: src/hooks/useCheckBalance.ts:36
msgid "Вам необходимо пополнить баланс лицевого счета для бесперебойной работы системы GSM мониторинга"
msgstr "You need to top up your personal account balance for the uninterrupted operation of the GSM monitoring system"

#: src/containers/OraclePage/EditDataTab/validationSchema.ts:12
msgid "Введите число"
msgstr "Enter a number"

#: src/containers/Terminals/Terminal/DeviceState/TerminalSummary.tsx:76
msgid "Версия платы Водоподготовки"
msgstr "Version of the Water preparing board"

#: src/containers/Update/Update.tsx:50
msgid "Версия прошивки"
msgstr "Firmware version"

#: src/containers/Migrations/Migrations.tsx:3679
msgid "Визуализация"
msgstr "Visualization"

#: src/containers/SystemMaintenance/SystemMaintenance.tsx:46
msgid "включена"
msgstr "enabled"

#: src/containers/SystemMaintenance/SystemMaintenance.tsx:87
msgid "Включить"
msgstr "Enable"

#: src/containers/SystemMaintenance/SystemMaintenance.tsx:82
msgid "Включить технические работы?"
msgstr "Enable maintenance mode?"

#: src/locales/constants.ts:19
#: src/locales/constants.ts:23
#: src/containers/Terminals/Terminal/DeviceState/TerminalSummary.tsx:37
msgid "Владелец"
msgstr "Owner"

#: src/features/demoAccess/ui/DemoAccessHint.tsx:10
msgid "Внимание! Это демонстрационный аккаунт. <0>Все адреса и суммы продаж вымышлены, любые совпадения с реальными адресами случайны</0>"
msgstr "Attention! This is a demo account. <0>All addresses and sales amounts are fictitious, any coincidences with real addresses are random</0>"

#: src/containers/DeviceList/columns/mobile.tsx:48
msgid "Вода"
msgstr "Water"

#: src/containers/DeviceList/constants.ts:26
msgid "Вода+"
msgstr "Water+"

#: src/containers/Terminals/Terminal/DeviceState/DeviceState.tsx:75
#: src/containers/Terminals/EditDevice/EditDeviceTabTitle.tsx:23
msgid "Водоподготовка"
msgstr "Water preparing"

#: src/containers/Login/LoginForm.tsx:115
msgid "Войти"
msgstr "Log in"

#: src/containers/Login/LoginForm.tsx:117
msgid "Восстановить"
msgstr "Recovery"

#: src/containers/Terminals/Terminal/DeviceLogs/DeviceLogs.tsx:93
#: src/containers/Services/BalanceHistory.tsx:25
msgid "Время"
msgstr "Time"

#: src/containers/Migrations/Migrations.tsx:2052
msgid "Время выполнения: {minutes} мин {seconds} сек"
msgstr "Duration: {minutes} min {seconds} sec"

#: src/containers/Migrations/Migrations.tsx:2053
msgid "Время выполнения: {seconds} сек"
msgstr "Duration: {seconds} sec"

#: src/containers/Migrations/Migrations.tsx:729
#: src/containers/Migrations/Migrations.tsx:1024
msgid "Время миграции"
msgstr "Migration timing"

#: src/containers/Terminals/EditDevice/AcidWashFields.tsx:141
msgid "Время набора раствора для промывки в мембрану"
msgstr "Time to set the rinsing solution in the membrane"

#: src/containers/Migrations/Migrations.tsx:712
#: src/containers/Migrations/Migrations.tsx:1004
msgid "Время оценки"
msgstr "Estimate timing"

#. placeholder {0}: data.firstSaleTs ? convertTimestampToLocalDateString(data.firstSaleTs) : 'нет продаж'
#: src/containers/OraclePage/ComputeTab/utils.ts:214
msgid "Время первой продажи: {0}"
msgstr "Time of the first sale: {0}"

#: src/hooks/useGroupsOptions.tsx:13
msgid "Все группы"
msgstr "All"

#: src/containers/Migrations/Migrations.tsx:3806
msgid "Все данные полностью"
msgstr "All data in full"

#: src/containers/Migrations/Migrations.tsx:3163
msgid "Все размеры приблизительные. В варианте «telemetry 6 мес.» только telemetry и telemetry mono ограничены шестью месяцами, остальные данные учитываются полностью."
msgstr "All sizes are approximate. In the “6-month telemetry” variant, only telemetry and telemetry mono are limited to six months; all other data is included in full."

#: src/containers/Encash/useEncashColumns.tsx:82
#: src/containers/DeviceList/columns/list.tsx:69
#: src/containers/Dashboard/AllMoney/utils.ts:29
#: src/containers/Dashboard/AllMoney/utils.ts:57
msgid "Всего"
msgstr "Total"

#: src/containers/Migrations/Migrations.tsx:3207
#: src/containers/Dashboard/Devices/utils.ts:59
msgid "Всего аппаратов"
msgstr "Total device count"

#: src/containers/Terminals/Terminal/DeviceState/TerminalFinState.tsx:126
msgid "Всего в аппарате"
msgstr "Total in device"

#: src/containers/Sales/SalesTotal.tsx:103
msgid "Всего за период <0>{formattedTotal}{delimiter}{formattedLiters}{wats}{liters}</0>"
msgstr "Total for the period <0>{formattedTotal}{delimiter}{formattedLiters}{wats}{liters}</0>"

#: src/containers/Encash/Encash.tsx:70
msgid "Всего за период <0>{formattedTotal}</0>"
msgstr "Total for the period <0>{formattedTotal}</0>"

#: src/containers/Dashboard/Users/Users.tsx:70
msgid "Всего зарегистрированных"
msgstr "Total registered"

#: src/containers/Migrations/Migrations.tsx:3203
msgid "Всего пользователей"
msgstr "Total users"

#: src/containers/Dashboard/Users/Users.tsx:49
msgid "Всего пользователей:"
msgstr "Total number of users:"

#: src/containers/Dashboard/BillingStats/columns.tsx:57
msgid "Всего счетов к обработке"
msgstr "Total bills"

#: src/containers/Dashboard/Geography/Geography.tsx:20
msgid "Всего устройств"
msgstr "Total number of devices"

#: src/containers/KnowledgeBase/Section.tsx:42
msgid "Вся база знаний"
msgstr "All articles"

#. placeholder {0}: convertTimestampToLocalDateString( data.period.userFromTs )
#. placeholder {1}: convertTimestampToLocalDateString(data.period.userToTs)
#: src/containers/OraclePage/ComputeTab/utils.ts:222
msgid "Вы выбрали Период с {0} по {1}."
msgstr "You have selected the period from {0} to {1}."

#: src/containers/Terminals/EditDevice/PromoField.tsx:15
msgid "Вы выключили режим Промоакция. Параметр Автостоп наличные/банк.карта установлен равным 0 литров"
msgstr "You have disabled the Promo mode. The AUTOSTOP parameter is set to 0 liters"

#: src/containers/Terminals/Terminal/DeviceState/MeterValue.tsx:93
msgid "Вы меняете показания: {metertLabel}"
msgstr "You change value of {metertLabel}"

#: src/containers/Encash/EncashComment.tsx:41
msgid "Вы можете добавить комментарий"
msgstr "You can add a comment"

#: src/containers/Dashboard/BillingStats/BillingStats.tsx:38
msgid "Выберите месяц за который хотите получить отчет"
msgstr "Pick month for report"

#: src/locales/constants.ts:7
msgid "Выберите точный адрес установки из списка"
msgstr "Select the exact installation address from the list"

#: src/containers/Dashboard/BillingStats/BillingLogs.tsx:63
msgid "Выберите услугу"
msgstr "Select service"

#: src/containers/Migrations/Migrations.tsx:2610
msgid "Выборочная миграция завершена"
msgstr "Selective migration completed"

#: src/components/LastServiceDate/LastServiceDate.tsx:152
msgid "Выбранная дата обслуживания установится для ВСЕХ аппаратов в личном кабинете"
msgstr "The selected service date will be set for ALL devices in your personal account."

#: src/containers/Migrations/Migrations.tsx:1073
msgid "Выгружает полную историю в Parquet, импортирует её в PostgreSQL и сохраняет резервную копию в MinIO"
msgstr "Exports the full history to Parquet, imports it into PostgreSQL, and saves a backup in MinIO"

#: src/containers/Migrations/SystemMigrations.tsx:204
msgid "Выгружено записей"
msgstr "Records exported"

#: src/containers/Dashboard/AllMoney/AllMoney.tsx:97
msgid "Выгрузить ручные корректировки"
msgstr "Download manual adjustments"

#: src/containers/Migrations/SystemMigrations.tsx:219
msgid "Выгрузка"
msgstr "Export"

#: src/containers/Migrations/SystemMigrations.tsx:48
msgid "Выгрузка в Parquet"
msgstr "Export to Parquet"

#: src/containers/Migrations/Migrations.tsx:263
#: src/containers/Migrations/Migrations.tsx:1227
#: src/containers/Migrations/Migrations.tsx:3384
msgid "Выгрузка из MinIO"
msgstr "Download from MinIO"

#: src/containers/Migrations/Migrations.tsx:1215
msgid "Выгрузка истории из DynamoDB"
msgstr "Exporting history from DynamoDB"

#: src/containers/Migrations/Migrations.tsx:1213
msgid "Выгрузка текущего состояния из DynamoDB"
msgstr "Exporting current state from DynamoDB"

#: src/containers/SystemMaintenance/SystemMaintenance.tsx:50
msgid "выключена"
msgstr "disabled"

#: src/containers/Terminals/EditDevice/DeviceAdditionalFields.tsx:30
msgid "Выключено"
msgstr "Disabled"

#: src/containers/SystemMaintenance/SystemMaintenance.tsx:87
msgid "Выключить"
msgstr "Disable"

#: src/containers/SystemMaintenance/SystemMaintenance.tsx:83
msgid "Выключить технические работы?"
msgstr "Disable maintenance mode?"

#: src/containers/Migrations/SystemMigrations.tsx:41
#: src/containers/Migrations/SystemMigrations.tsx:103
#: src/containers/Migrations/Migrations.tsx:264
#: src/containers/Migrations/Migrations.tsx:281
#: src/containers/Migrations/Migrations.tsx:1173
#: src/containers/Migrations/Migrations.tsx:2776
msgid "Выполняется"
msgstr "In progress"

#: src/containers/Migrations/Migrations.tsx:1184
msgid "Выполняется для"
msgstr "Running for"

#: src/containers/Sales/Sales.tsx:145
msgid "Выслать общий отчет"
msgstr "Send a general report"

#: src/containers/Sales/Sales.tsx:138
msgid "Выслать отчет о продажах"
msgstr "Send a sales report"

#: src/containers/Dashboard/AllMoney/utils.ts:19
msgid "Гарантийное оборудование"
msgstr "Warranty equipment"

#: src/containers/Dashboard/Dashboard.tsx:31
msgid "География"
msgstr "Geography"

#: src/config/menu.tsx:36
msgid "Главная"
msgstr "Home"

#: src/containers/Terminals/Terminal/DeviceState/TerminalSummary.tsx:156
msgid "Голосовой помощник"
msgstr "Voice Assistant"

#: src/locales/constants.ts:49
msgid "Группа"
msgstr "Group"

#: src/containers/Dashboard/Devices/Devices.tsx:41
#: src/containers/Dashboard/AllMoney/AllMoney.tsx:80
msgid "Группа:"
msgstr "Group:"

#: src/config/menu.tsx:48
msgid "Группы пользователей"
msgstr "User groups"

#: src/ui-kit/Form/Switch/Switch.tsx:138
#: src/components/Switch.tsx:80
msgid "Да"
msgstr "Yes"

#: src/containers/Terminals/Terminal/DeviceLogs/DeviceLogs.tsx:113
msgid "Данные"
msgstr "Data"

#: src/utils/http.ts:22
msgid "Данные не доступны в демо-режиме"
msgstr "Some data is not available in demo"

#: src/containers/Staff/StaffForm.tsx:35
msgid "Данные о сотруднике обновлены"
msgstr "Staff has been updated"

#: src/containers/Staff/StaffForm.tsx:57
msgid "Данные о сотруднике удалены"
msgstr "Staff has been deleted"

#: src/containers/Encash/useEncashColumns.tsx:104
#: src/containers/Dashboard/BillingStats/BillingLogs.tsx:10
msgid "Дата"
msgstr "Date"

#: src/locales/constants.ts:14
#: src/containers/Terminals/Terminal/DeviceState/TerminalSummary.tsx:49
#: src/containers/Terminals/EditDevice/EditDevice.tsx:162
msgid "Дата обслуживания"
msgstr "Last service date"

#: src/components/LastServiceDate/LastServiceDate.tsx:106
msgid "Дата последнего обслуживания обновлена"
msgstr "Last maintenance date updated"

#: src/containers/Migrations/Migrations.tsx:3918
msgid "Дата создания"
msgstr "Creation date"

#: src/containers/Migrations/Migrations.tsx:753
msgid "Дата создания аппарата"
msgstr "Device creation date"

#: src/containers/Migrations/Migrations.tsx:1043
msgid "Дата создания пользователя"
msgstr "User creation date"

#: src/containers/Terminals/EditDevice/MainboardFields/options.ts:121
msgid "Датчик столба жидкости"
msgstr "Liquid column sensor"

#: src/containers/Terminals/Terminal/DeviceState/DeviceState.tsx:68
msgid "Датчики"
msgstr "Sensors"

#: src/containers/OraclePage/EditDataTab/validationSchema.ts:21
msgid "Даты не должны быть одинаковыми"
msgstr "Dates should not be the same"

#: src/containers/DeviceList/columns/base.tsx:44
msgid "двухкамерный"
msgstr "dual-chamber"

#: src/containers/Terminals/Terminal/DeviceState/TerminalBoard.tsx:180
#: src/containers/Terminals/EditDevice/MainboardFields/options.ts:94
msgid "двухстрочный"
msgstr "double-line"

#: src/containers/Terminals/Terminal/DeviceState/TerminalBoard.tsx:182
msgid "двухстрочный моргающий"
msgstr "double-line blinking"

#: src/containers/Terminals/EditDevice/MainboardFields/options.ts:98
msgid "двухстрочный по очереди"
msgstr "two line in turn"

#: src/containers/Migrations/SystemMigrations.tsx:278
#: src/containers/Migrations/Migrations.tsx:600
#: src/containers/Migrations/Migrations.tsx:834
#: src/containers/Migrations/Migrations.tsx:3401
#: src/containers/Migrations/Migrations.tsx:3602
msgid "Действия"
msgstr "Actions"

#: src/components/Stats/constants.ts:11
msgid "День"
msgstr "Day"

#: src/containers/DeviceList/constants.ts:23
#: src/containers/DeviceList/columns/mobile.tsx:143
#: src/containers/DeviceList/columns/desktop.tsx:143
#: src/containers/Dashboard/Dashboard.tsx:25
#: src/components/Stats/constants.ts:17
msgid "Деньги"
msgstr "Money"

#: src/containers/Migrations/Migrations.tsx:3159
msgid "Детали миграции"
msgstr "Migration details"

#: src/containers/Dashboard/Dashboard.tsx:28
msgid "Динамика билинга"
msgstr "Billing dynamics"

#: src/containers/DeviceList/constants.ts:28
msgid "Динамика продаж"
msgstr "Sales dynamics"

#: src/containers/Migrations/Migrations.tsx:2840
msgid "Диск pod: свободно / всего"
msgstr "Pod disk: free / total"

#: src/containers/Terminals/EditDevice/AcidWashFields.tsx:120
msgid "Диффузионная промывка"
msgstr "Diffusion washing"

#: src/containers/Migrations/Migrations.tsx:3265
msgid "Длительности суммируются по пользователям. Этапы конвейера выполняются параллельно, поэтому фактическое календарное время миграции может быть меньше указанного."
msgstr "Durations are summed across users. Pipeline stages run in parallel, so the actual elapsed migration time may be shorter than shown."

#: src/containers/Terminals/EditDevice/AcidWashFields.tsx:140
msgid "Длительность набора состава сек"
msgstr "The duration of the composition set is seconds"

#: src/containers/Terminals/EditDevice/AcidWashFields.tsx:148
msgid "Длительность промывки ХВС {tflUnit}"
msgstr "Duration of cold-water washing"

#: src/containers/Login/LoginForm.tsx:109
msgid "Для demo-доступа используйте <0>demo</0> в качестве логина и любой пароль"
msgstr "For demo access, use <0>demo</0> as your username and any password"

#: src/containers/Terminals/EditDevice/DeviceAdditionalFields.tsx:69
msgid "Для аппарата на дату {SunCalcDate} время рассвета:{SunCalcSunrise}, время заката: {SunCalcSunset} (выкл/вкл подсветки произойдет в течение часа после рассвета/заката, соответственно)"
msgstr "For the device on date {SunCalcDate}, sunrise time: {SunCalcSunrise}, sunset time: {SunCalcSunset} (backlight off/on will occur within an hour after sunrise/sunset, respectively)"

#: src/containers/Services/Services.tsx:251
msgid "Для вас нет доступных услуг"
msgstr "There are no available services for you"

#: src/containers/Migrations/DeviceStateComparisonModal.tsx:351
msgid "Для временных меток показана разница в секундах: PostgreSQL минус DynamoDB. Положительное значение означает, что метка PostgreSQL позже, отрицательное — раньше."
msgstr "For timestamps, the difference is shown in seconds: PostgreSQL minus DynamoDB. A positive value means the PostgreSQL timestamp is later; a negative value means it is earlier."

#: src/containers/Staff/Staff.tsx:38
msgid "Для добавления, изменения, удаления данных о сотрудниках необходимо обратиться в техническую поддержку телеграмм <0>@alivewaternewbot</0>"
msgstr "To add, change, or delete employee data, please contact Telegram technical support <0>@alivewaternewbot</0>"

#: src/features/deviceAlerts/i18n/translations.ts:20
msgid "Для корректной работы оборудования вам необходимо его перезагрузить"
msgstr "Device need to be restart for correct work"

#: src/containers/Services/Services.tsx:113
msgid "Для отображения данных, на балансе лицевого счета недостаточно средств"
msgstr "There are not enough funds on the personal account balance to display the data."

#: src/containers/Migrations/Migrations.tsx:3097
msgid "Для таблиц от 10 000 строк данные распределяются между подключениями. Ноль приостанавливает запуск новых записей; уже начатая запись завершится."
msgstr "For tables with 10,000 rows or more, data is distributed across connections. Zero pauses new writes; a write already in progress will finish."

#: src/containers/OraclePage/EditDataTab/OracleHistoryInput/HistoryDataForm/HistoryDataForm.tsx:126
msgid "Добавить новую запись"
msgstr "Add new record"

#: src/containers/Staff/Staff.tsx:33
msgid "Добавить сотрудника"
msgstr "Add staff"

#: src/containers/Migrations/Migrations.tsx:3513
msgid "Добавлено аппаратов: {addedDeviceCount}"
msgstr "Devices added: {addedDeviceCount}"

#: src/containers/Migrations/DeviceStateComparisonModal.tsx:335
msgid "Добавлено в PostgreSQL"
msgstr "Added in PostgreSQL"

#: src/containers/Migrations/Migrations.tsx:3327
msgid "Добавлено пользователей: {synchronizedCount}; удалено из DynamoDB: {deletedUserCount}; восстановлено: {restoredUserCount}"
msgstr "Users added: {synchronizedCount}; deleted from DynamoDB: {deletedUserCount}; restored: {restoredUserCount}"

#: src/containers/Terminals/Terminal/DeviceState/TerminalBoard.tsx:110
msgid "Добро пожаловать"
msgstr "Welcome"

#: src/containers/Terminals/Terminal/DeviceState/TerminalBoard.tsx:114
msgid "Добро пожаловать + номер техподдержки"
msgstr "Welcome + support phone number"

#: src/containers/Terminals/EditDevice/MainboardFields/options.ts:76
msgid "Добро пожаловать в 1 строке и номер техподдержки в 3-4 строках"
msgstr "ome to 1 line and technical support number in 3-4 lines"

#: src/containers/Terminals/EditDevice/MainboardFields/options.ts:68
msgid "Добро пожаловать в 1 строке."
msgstr "Welcome to 1 line."

#: src/locales/constants.ts:22
msgid "Долгота"
msgstr "Latitude"

#: src/config/menu.tsx:79
msgid "Домашние системы очистки"
msgstr "HWT"

#: src/locales/constants.ts:46
msgid "Дополнительно высылать отчеты на следующие адреса"
msgstr "Additionally send reports to the following addresses"

#: src/components/ServiceNotificationModal.tsx:34
msgid "Доступ к GSM мониторингу предоставляется на платной основе"
msgstr "Access to GSM monitoring is provided on a paid basis"

#: src/containers/DeviceList/DeviceList.tsx:178
msgid "Доступно только для оборудования с оригинальной платой водоподготовки Живая вода"
msgstr "Available only for equipment with the original Alive Water water treatment board"

#: src/containers/Dashboard/AllMoney/utils.ts:52
msgid "Другие"
msgstr "Other"

#: src/components/CartridgeValue/EditValueModal.tsx:158
msgid "Если вы заменили счетчик ХВС - нажмите на эту кнопку. Это важно чтобы корректно рассчитать ОСТАЛОСЬ ДО ЗАМЕНЫ у картриджей 1-3 ступеней очистки"
msgstr "If you have replaced the cold-water meter, press this button. This is important to correctly calculate REMAINING BEFORE REPLACEMENT for purification cartridges of stages 1–3."

#: src/containers/Terminals/Terminal/DeviceState/TerminalBoard.tsx:108
msgid "Живая вода"
msgstr "Brand"

#: src/containers/Terminals/EditDevice/MainboardFields/options.ts:64
msgid "Живая вода в 1 строке"
msgstr "Alivewater in 1 line"

#. placeholder {0}: DateTime.fromMillis(Number(date)) .setLocale('ru-ru') .toFormat('dd-MM-yyyy')
#: src/containers/Report/Report.tsx:57
msgid "за {0}"
msgstr "for {0}"

#: src/containers/Services/Services.tsx:185
msgid "За каждую ДСО, указанную на данной вкладке, удерживается {hwtPrice} в месяц за сервис GPS-МОНИТОРИНГ КОНТРОЛЯ ПАРАМЕТРОВ ОБОРУДОВАНИЯ - ДСО."
msgstr "For each HWT specified on this tab, {hwtPrice} is withheld per month for the GPS MONITORING OF EQUIPMENT PARAMETERS CONTROL service - HWT."

#: src/containers/Services/Services.tsx:173
msgid "За каждый аппарат, указанный на данной вкладке, удерживается {moniProPrice} в месяц за сервис GPS-МОНИТОРИНГ КОНТРОЛЯ ПАРАМЕТРОВ ОБОРУДОВАНИЯ. Если у вас нет необходимости в использовании этого сервиса для конкретного аппарата - вам необходимо удалить аппарат из системы. Для удаления - обратитесь в службу технической поддержки."
msgstr "and each device specified on this tab is charged {moniProPrice} per month for the GPS MONITORING service of EQUIPMENT PARAMETERS CONTROL. If you do not need to use this service for a specific device, you must delete the device from the system. To delete, contact technical support."

#: src/containers/OraclePage/ComputeTab/utils.ts:237
msgid "За это время не было продаж и расходов (расходы считаются только там где есть продажи):"
msgstr "There were no sales and expenses during this time (expenses are calculated only where there are sales):"

#: src/containers/OraclePage/ComputeTab/utils.ts:234
msgid "За это время:"
msgstr "During this time:"

#: src/containers/Users/UserMenu.tsx:164
#: src/containers/Users/UserMenu.tsx:215
msgid "Заблокировать"
msgstr "Block"

#: src/containers/Users/UserMenu.tsx:163
msgid "Заблокировать пользователя?"
msgstr "Do you want block user?"

#: src/containers/Migrations/SystemMigrations.tsx:42
#: src/containers/Migrations/Migrations.tsx:265
#: src/containers/Migrations/Migrations.tsx:282
msgid "Завершена"
msgstr "Completed"

#: src/containers/Migrations/SystemMigrations.tsx:80
msgid "Завершение"
msgstr "Finished"

#: src/containers/Migrations/Migrations.tsx:1233
msgid "Завершение миграции"
msgstr "Finalizing migration"

#: src/containers/Migrations/SystemMigrations.tsx:51
#: src/containers/Migrations/SystemMigrations.tsx:104
msgid "Завершено"
msgstr "Finished"

#: src/containers/Migrations/Migrations.tsx:1223
msgid "Загрузка истории в PostgreSQL"
msgstr "Loading history into PostgreSQL"

#: src/containers/Migrations/SystemMigrations.tsx:127
msgid "Загрузка статуса…"
msgstr "Loading status…"

#: src/containers/Migrations/Migrations.tsx:1217
msgid "Загрузка текущего состояния в PostgreSQL"
msgstr "Loading current state into PostgreSQL"

#: src/containers/Dashboard/AllMoney/AllMoney.tsx:96
#: src/components/Stats/UserDevices.tsx:93
msgid "Загрузка..."
msgstr "Loading..."

#: src/features/deviceAlerts/i18n/translations.ts:9
msgid "Закончилась вода в баке. Возможно, отключен водопровод или имеются другие проблемы с аппаратом"
msgstr "Out of water in the tank"

#: src/containers/Sales/DeviceIncome.tsx:62
#: src/containers/Omnidesk/OmniChat.tsx:46
msgid "Закрыть"
msgstr "Close"

#: src/containers/Migrations/Migrations.tsx:1221
msgid "Замена monotonic telemetry в PostgreSQL"
msgstr "Replacing monotonic telemetry in PostgreSQL"

#: src/components/CartridgeValue/EditValueModal.tsx:57
#: src/components/CartridgeValue/EditValueModal.tsx:199
msgid "Замена картриджа {name}"
msgstr "Cartridge Replacement {name}"

#: src/containers/Migrations/SystemMigrations.tsx:207
msgid "Записано в Redis"
msgstr "Records written to Redis"

#: src/containers/Migrations/SystemMigrations.tsx:49
msgid "Запись в Redis"
msgstr "Writing to Redis"

#: src/containers/Migrations/Migrations.tsx:1333
msgid "Запустить миграцию"
msgstr "Start migration"

#: src/containers/Migrations/Migrations.tsx:1323
msgid "Запустить оценку"
msgstr "Start estimation"

#: src/containers/Migrations/Migrations.tsx:3263
msgid "Затрачено на миграцию, чч:мм:сс (≈)"
msgstr "Time spent on migration, hh:mm:ss (≈)"

#: src/containers/Migrations/Migrations.tsx:3247
msgid "Затрачено на оценку, чч:мм:сс"
msgstr "Time spent on estimation, hh:mm:ss"

#: src/containers/Migrations/Migrations.tsx:3040
msgid "Значение сохраняется после отпускания ползунка. Ноль приостанавливает новые запросы к DynamoDB."
msgstr "The value is saved when the slider is released. Zero pauses new DynamoDB requests."

#: src/containers/SystemMaintenance/MaintenancePage.tsx:13
msgid "Идут технические работы"
msgstr "Maintenance is underway"

#: src/components/EditAuditComment/EditAuditCommentModal.tsx:70
msgid "Изменение комментария"
msgstr "Edit Comment"

#: src/containers/Migrations/Migrations.tsx:3512
msgid "Изменено аппаратов: {synchronizedDeviceCount}"
msgstr "Devices changed: {synchronizedDeviceCount}"

#: src/containers/Services/ChangeBalance.tsx:60
msgid "Изменить"
msgstr "Change"

#: src/components/LastServiceDate/LastServiceDate.tsx:143
msgid "Изменить дату обслуживания: {Address}"
msgstr "Change the maintenance date: {Address}"

#: src/components/LastServiceDate/LastServiceDate.tsx:151
msgid "Изменить для всех"
msgstr "Change for all"

#: src/containers/Migrations/Migrations.tsx:3362
msgid "Изменить статус миграции"
msgstr "Change migration status"

#: src/containers/SystemMaintenance/SystemMaintenance.tsx:85
msgid "Изменяющие запросы portal и обработка сообщений worker будут приостановлены."
msgstr "Mutating portal requests and worker message processing will be paused."

#: src/containers/Migrations/SystemMigrations.tsx:224
msgid "Импорт"
msgstr "Import"

#: src/locales/constants.ts:28
msgid "импульс/кВт"
msgstr "pulse/kW"

#: src/locales/constants.ts:29
msgid "импульс/литр"
msgstr "pulse/liter"

#: src/locales/constants.ts:48
msgid "Имя"
msgstr "Name"

#: src/containers/Terminals/EditDevice/WifiFields.tsx:41
msgid "Имя сети (SSID)"
msgstr "Network name (SSID)"

#: src/components/ConnectBot/ConnectMaxBot.tsx:46
#: src/components/ConnectBot/ConnectMaxBot.tsx:263
#: src/components/ConnectBot/ConnectMaxBot.tsx:269
#: src/components/ConnectBot/ConnectBot.tsx:47
#: src/components/ConnectBot/ConnectBot.tsx:273
#: src/components/ConnectBot/ConnectBot.tsx:279
msgid "Имя скрыто"
msgstr "Name hidden"

#: src/containers/Terminals/Terminal/Device.tsx:103
#: src/containers/Migrations/Migrations.tsx:652
#: src/containers/Migrations/Migrations.tsx:940
#: src/containers/Migrations/Migrations.tsx:3812
#: src/config/menu.tsx:66
msgid "Инкассации"
msgstr "Encashments"

#: src/containers/Main/Header.tsx:136
msgid "Интернет магазин"
msgstr "Shop"

#: src/containers/Terminals/EditDevice/EditDeviceTabs.tsx:65
msgid "Информация"
msgstr "Information"

#: src/containers/OraclePage/EditDataTab/OracleHistoryInput/HistoryDataForm/HistoryDataForm.tsx:85
msgid "исторические данные"
msgstr "historical data"

#: src/containers/Services/BalanceHistory.tsx:102
msgid "История операций"
msgstr "Transaction history"

#: src/containers/Migrations/DeviceStateComparisonModal.tsx:360
msgid "Как рассчитывается разница"
msgstr "How the difference is calculated"

#: src/containers/Services/PaymentType.tsx:39
#: src/containers/Services/PaymentType.tsx:40
msgid "Карты эмитированные банками РФ"
msgstr "Cards issued by Russian banks"

#: src/containers/Services/PaymentType.tsx:38
msgid "Карты эмитированные иностранными банками"
msgstr "Cards issued by non-Russian banks"

#: src/locales/constants.ts:31
msgid "кВт*час"
msgstr "kW*hour"

#: src/locales/constants.ts:30
msgid "кВт/час"
msgstr "kW/hour"

#: src/containers/Migrations/SystemMigrations.tsx:145
#: src/containers/Migrations/SystemMigrations.tsx:265
msgid "Ключи Redis"
msgstr "Redis keys"

#: src/containers/Login/LoginForm.tsx:50
msgid "Код восстановления выслан на почту"
msgstr "Recovery code was sent to the email"

#: src/containers/Users/UserMenu.tsx:78
msgid "Код для смены пароля отправлен"
msgstr "Confirmation code was sent"

#: src/containers/Migrations/Migrations.tsx:3788
msgid "Кол-во"
msgstr "Count"

#: src/containers/Dashboard/Devices/utils.ts:69
msgid "Количество активный аппаратов"
msgstr "Number of active devices"

#: src/containers/UserGroups/useUserGroupColumns.tsx:63
msgid "Количество активных аппаратов"
msgstr "Active devices count"

#: src/containers/UserGroups/useUserGroupColumns.tsx:58
#: src/containers/Migrations/Migrations.tsx:3726
#: src/containers/Dashboard/Devices/Devices.tsx:54
msgid "Количество аппаратов"
msgstr "Device count"

#: src/containers/Terminals/Terminal/DeviceState/BotlerStatus.tsx:24
msgid "Количество бутылок в ячейках"
msgstr "Number of bottles in cells"

#: src/containers/UserGroups/useUserGroupColumns.tsx:53
msgid "Количество пользователей"
msgstr "Users count"

#: src/containers/Services/Services.tsx:195
msgid "Количество установок ДСО"
msgstr "Number of HWT installations"

#: src/containers/Staff/StaffForm.tsx:80
msgid "Комментарий"
msgstr "Comment"

#: src/containers/Services/ChangeBalance.tsx:56
msgid "Комментарий"
msgstr "Comment"

#: src/components/LastServiceDate/LastServiceDate.tsx:162
#: src/components/EditAuditComment/EditAuditCommentModal.tsx:86
msgid "Комментарий по желанию"
msgstr "Comment (optional)"

#: src/components/CommentForm/CommentForm.tsx:29
msgid "Комментарий сохранен"
msgstr "Comment saved"

#: src/components/EditAuditComment/EditAuditCommentModal.tsx:55
msgid "Комментарий успешно изменен"
msgstr "Comment successfully edited"

#: src/locales/constants.ts:44
msgid "Компания"
msgstr "Company"

#: src/containers/Migrations/Migrations.tsx:918
#: src/containers/Migrations/Migrations.tsx:2789
msgid "Конвейер миграции"
msgstr "Migration pipeline"

#: src/containers/Migrations/Migrations.tsx:388
msgid "Конец"
msgstr "End"

#: src/containers/Terminals/EditDevice/AcidWashFields.tsx:130
msgid "Концентрация состава"
msgstr "Composition concentration"

#: src/features/deviceAlerts/i18n/translations.ts:14
msgid "Кончилась сдача"
msgstr "The change is over"

#: src/components/DeviceRemain.tsx:83
msgid "Корректировать остаток воды"
msgstr "Adjust the remaining water"

#: src/containers/Services/ChangeBalance.tsx:47
msgid "Корректировка баланса:"
msgstr "Balance adjustment:"

#: src/containers/Services/BalanceHistory.tsx:57
msgid "Кто сделал"
msgstr "Who"

#: src/containers/Terminals/Terminal/DeviceState/TerminalFinState.tsx:132
msgid "Купюры"
msgstr "Banknotes"

#: src/locales/constants.ts:32
#: src/containers/DeviceList/columns/mobile.tsx:55
#: src/containers/DeviceList/columns/desktop.tsx:154
msgid "л"
msgstr "l"

#: src/locales/constants.ts:33
#: src/containers/DeviceList/columns/mobile.tsx:106
msgid "л/мин"
msgstr "l/min"

#: src/containers/Sales/useSalesColumns.tsx:39
msgid "Лейбл"
msgstr "Label"

#: src/containers/Migrations/Migrations.tsx:2003
msgid "Лимит параллельных подключений PostgreSQL обновлён: {value}"
msgstr "PostgreSQL parallel connection limit updated: {value}"

#: src/containers/Migrations/Migrations.tsx:1986
msgid "Лимит чтения DynamoDB обновлён: {value} RCU/s"
msgstr "DynamoDB read limit updated: {value} RCU/s"

#: src/components/Stats/constants.ts:18
msgid "Литры"
msgstr "Liters"

#: src/containers/Terminals/Terminal/Device.tsx:132
msgid "Логи"
msgstr "Logs"

#: src/containers/Dashboard/BillingStats/BillingLogs.tsx:62
msgid "Логи билинга"
msgstr "Billing logs"

#: src/config/menu.tsx:111
msgid "Логи пользователя"
msgstr "Logs"

#: src/locales/constants.ts:56
#: src/containers/Staff/StaffUserSelect.tsx:48
#: src/containers/Migrations/Migrations.tsx:821
#: src/containers/Login/LoginForm.tsx:74
msgid "Логин"
msgstr "Username"

#: src/containers/Migrations/SystemMigrations.tsx:240
msgid "Локальный файл сохранён"
msgstr "Local file retained"

#: src/containers/Migrations/formatDuration.tsx:24
msgid "м"
msgstr "m"

#: src/locales/constants.ts:39
msgid "м³"
msgstr "m³"

#: src/containers/Services/Recharge.tsx:68
msgid "Максимальная сумма платежа {maxPaymentSum}₽"
msgstr "Maximum payment amount {maxPaymentSum}₽"

#: src/features/deviceAlerts/i18n/translations.ts:15
msgid "Малое количество средств на балансе SIM карты"
msgstr "Low amount of funds on the balance of the SIM card"

#: src/components/Stats/constants.ts:13
msgid "Месяц"
msgstr "Month"

#: src/containers/Migrations/Migrations.tsx:2746
#: src/config/menu.tsx:138
msgid "Миграции"
msgstr "Migrations"

#: src/containers/Migrations/Migrations.tsx:3129
msgid "Миграция данных"
msgstr "Data migration"

#: src/containers/Migrations/Migrations.tsx:2756
msgid "Миграция пользовательских данных"
msgstr "User data migration"

#: src/containers/Migrations/Migrations.tsx:2134
#: src/containers/Migrations/Migrations.tsx:2212
msgid "Миграция пользователя завершена"
msgstr "User migration completed"

#: src/containers/Migrations/Migrations.tsx:2150
#: src/containers/Migrations/Migrations.tsx:2229
msgid "Миграция пользователя завершилась с ошибкой"
msgstr "User migration failed"

#: src/containers/Migrations/Migrations.tsx:2160
msgid "Миграция пользователя запущена"
msgstr "User migration started"

#: src/containers/Migrations/Migrations.tsx:3211
msgid "Мигрировало пользователей"
msgstr "Migrated users"

#: src/containers/Migrations/Migrations.tsx:3557
msgid "Мигрировать только…"
msgstr "Migrate only…"

#: src/locales/constants.ts:35
msgid "мин"
msgstr "min"

#: src/containers/Services/Recharge.tsx:67
msgid "Минимальна сумма платежа {minPaymentSum}₽"
msgstr "Minimum payment amount {minPaymentSum}₽"

#: src/containers/Terminals/Terminal/DeviceState/TerminalFinState.tsx:138
msgid "Монеты"
msgstr "Coins"

#: src/containers/Dashboard/AllMoney/utils.ts:37
msgid "Мониторинг"
msgstr "Monitoring"

#: src/containers/Migrations/formatDuration.tsx:45
msgid "мс"
msgstr "ms"

#: src/containers/Services/Services.tsx:114
msgid "Нажмите на кнопку \"Пополнить баланс\" для пополнения баланса"
msgstr "Click on the \"Top up your balance\" to top up your balance"

#: src/components/CartridgeValue/EditValueModal.tsx:109
msgid "Нажмите ПЕРЕСЧИТАТЬ, если вы действительно поменяли счетчик ХВС на новый. Параметр ОСТАЛОСЬ ДО ЗАМЕНЫ будет пересчитан чтобы показывать корректные значения"
msgstr "Press RECALCULATE if you have indeed replaced the cold-water meter with a new one. The REMAINING BEFORE REPLACEMENT value will be recalculated to display correct figures."

#: src/containers/UserGroups/useUserGroupColumns.tsx:30
msgid "Название группы"
msgstr "Group"

#: src/locales/constants.ts:57
msgid "Налоговый идентификатор"
msgstr "BIN"

#: src/containers/Terminals/EditDevice/MainboardFields/BottlerFields.tsx:13
msgid "Настройки бутылочника"
msgstr "Bottler settings"

#: src/containers/Terminals/EditDevice/NotificationSettingsFields.tsx:22
msgid "Настройки оповещений"
msgstr "Notification Settings"

#: src/containers/Terminals/EditDevice/WifiFields.tsx:38
msgid "Настройки подключения по Wi-Fi"
msgstr "Wi-Fi configuration"

#: src/containers/Migrations/SystemMigrations.tsx:72
#: src/containers/Migrations/Migrations.tsx:382
msgid "Начало"
msgstr "Start"

#: src/containers/Migrations/SystemMigrations.tsx:299
msgid "Начать миграцию"
msgstr "Start migration"

#: src/containers/Migrations/Migrations.tsx:1166
msgid "Не выполняется"
msgstr "Not running"

#: src/containers/Migrations/SystemMigrations.tsx:130
msgid "Не запускалась"
msgstr "Not started"

#: src/containers/Report/ReportContainer.tsx:26
msgid "Не найден корневой элемент"
msgstr "Root element not found"

#: src/containers/Migrations/Migrations.tsx:278
#: src/containers/Migrations/Migrations.tsx:3374
msgid "Не начата"
msgstr "Not started"

#: src/components/LastServiceDate/LastServiceDate.tsx:184
msgid "Не обслуживался"
msgstr "Not maintened"

#: src/containers/Services/Services.tsx:72
msgid "Не подключена"
msgstr "Not connected"

#: src/containers/Terminals/Terminal/DeviceState/TerminalSummary.tsx:87
msgid "НЕ РЕКОМЕНДУЕТСЯ прошивать аппарат прошивкой tcp (это прошивки с индексом 6.00.ХХХ) Для таких аппаратов рекомендуем прошивку 4.34.37 или 4.37.67"
msgstr "It is NOT RECOMMENDED to flash the device with tcp firmware (these are firmware with the index 6.00.XXX) For such devices, we recommend firmware 4.34.37 or 4.37.67."

#: src/containers/Migrations/Migrations.tsx:2616
msgid "Не удалось выполнить выборочную миграцию аппаратов"
msgstr "Failed to perform selective device migration"

#: src/containers/Migrations/SystemMigrations.tsx:189
msgid "Не удалось выполнить действие. Проверьте статус и повторите попытку."
msgstr "Action failed. Check the status and try again."

#: src/containers/Encash/EncashComment.tsx:31
msgid "Не удалось добавить комментарий"
msgstr "Failed to add comment"

#: src/containers/Migrations/Migrations.tsx:1960
msgid "Не удалось запустить миграцию данных"
msgstr "Failed to start data migration"

#: src/containers/Migrations/Migrations.tsx:2174
msgid "Не удалось запустить миграцию пользователя"
msgstr "Failed to start user migration"

#: src/containers/Migrations/Migrations.tsx:1934
msgid "Не удалось запустить оценку пользователей"
msgstr "Failed to start user estimation"

#: src/containers/Services/ChangeBalance.tsx:33
msgid "Не удалось изменить баланс"
msgstr "Failed to change balance"

#: src/containers/SystemMaintenance/SystemMaintenance.tsx:120
msgid "Не удалось изменить режим технических работ"
msgstr "Failed to update maintenance mode"

#: src/containers/Migrations/Migrations.tsx:2570
msgid "Не удалось изменить статус миграции пользователей"
msgstr "Failed to change user migration status"

#: src/containers/Staff/StaffForm.tsx:39
msgid "Не удалось обновить данные о сотруднике"
msgstr "Couldn't update staff data"

#: src/components/LastServiceDate/LastServiceDate.tsx:110
msgid "Не удалось обновить дату последнего обслуживания"
msgstr "Couldn't update last maintenance date"

#: src/containers/Migrations/Migrations.tsx:2010
msgid "Не удалось обновить лимит подключений PostgreSQL"
msgstr "Failed to update the PostgreSQL connection limit"

#: src/containers/Migrations/Migrations.tsx:1991
msgid "Не удалось обновить лимит чтения DynamoDB"
msgstr "Failed to update the DynamoDB read limit"

#: src/containers/Migrations/SystemMigrations.tsx:176
msgid "Не удалось обновить статус миграции"
msgstr "Failed to refresh migration status"

#: src/containers/Migrations/Migrations.tsx:1959
msgid "Не удалось остановить миграцию данных"
msgstr "Failed to stop data migration"

#: src/containers/Migrations/Migrations.tsx:1933
msgid "Не удалось остановить оценку пользователей"
msgstr "Failed to stop user estimation"

#: src/containers/Migrations/Migrations.tsx:3638
msgid "Не удалось получить аппараты для миграции"
msgstr "Failed to load devices for migration"

#: src/containers/Migrations/Migrations.tsx:3704
msgid "Не удалось получить данные для визуализации"
msgstr "Failed to load visualization data"

#: src/containers/Migrations/Migrations.tsx:3061
msgid "Не удалось получить лимит подключений PostgreSQL"
msgstr "Failed to retrieve the PostgreSQL connection limit"

#: src/containers/Migrations/Migrations.tsx:3010
msgid "Не удалось получить лимит чтения DynamoDB"
msgstr "Failed to retrieve the DynamoDB read limit"

#: src/containers/Migrations/Migrations.tsx:3447
msgid "Не удалось получить пользователей для миграции"
msgstr "Failed to retrieve users for migration"

#: src/containers/Migrations/Migrations.tsx:3197
msgid "Не удалось получить сводные показатели миграции"
msgstr "Failed to load migration summary"

#: src/components/ConnectBot/ConnectMaxBot.tsx:87
#: src/components/ConnectBot/ConnectBot.tsx:88
msgid "Не удалось получить ссылку на подключение"
msgstr "Failed to get connection link"

#: src/containers/Migrations/Migrations.tsx:2766
msgid "Не удалось получить статус migrator"
msgstr "Failed to retrieve migrator status"

#: src/containers/Migrations/Migrations.tsx:2245
msgid "Не удалось получить статус миграции пользователя"
msgstr "Failed to retrieve user migration status"

#: src/containers/Migrations/Migrations.tsx:2308
msgid "Не удалось получить статус расчёта"
msgstr "Failed to retrieve estimation status"

#: src/containers/SystemMaintenance/SystemMaintenance.tsx:130
msgid "Не удалось получить статусы worker pod'ов"
msgstr "Failed to get worker pod statuses"

#: src/containers/Sales/DeviceIncome.tsx:33
msgid "Не удалось пополнить баланс"
msgstr "Failed to top up balance"

#: src/containers/Migrations/Migrations.tsx:2085
#: src/containers/Migrations/Migrations.tsx:2095
#: src/containers/Migrations/Migrations.tsx:2294
msgid "Не удалось рассчитать метрики пользователя"
msgstr "Failed to estimate user metrics"

#: src/containers/Migrations/Migrations.tsx:3524
msgid "Не удалось синхронизировать аппараты"
msgstr "Failed to synchronize devices"

#: src/containers/Migrations/Migrations.tsx:3334
msgid "Не удалось синхронизировать пользователей"
msgstr "Failed to synchronize users"

#: src/components/ConnectBot/ConnectMaxBot.tsx:125
#: src/components/ConnectBot/ConnectBot.tsx:133
msgid "Не удалось скопировать ссылку в буфер обмена, сделайте это вручную"
msgstr "Failed to copy link to clipboard, please do it manually"

#: src/components/DeviceRemain.tsx:31
msgid "Не удалось скорректировать остаток"
msgstr "Couldn't adjust remaining water"

#: src/containers/Terminals/NewDevice/NewDevice.tsx:59
msgid "Не удалось создать аппарат"
msgstr "Failed to create device"

#: src/components/CommentForm/CommentForm.tsx:33
msgid "Не удалось сохранить комментарий"
msgstr "Failed to save comment"

#: src/containers/Migrations/SystemMigrations.tsx:235
msgid "Не удалось сохранить файл в MinIO"
msgstr "Failed to save the file to MinIO"

#: src/containers/Migrations/DeviceStateComparisonModal.tsx:321
msgid "Не удалось сравнить состояния аппарата"
msgstr "Failed to compare device states"

#: src/containers/Migrations/Migrations.tsx:2653
msgid "Не удалось сравнить состояния аппаратов"
msgstr "Failed to compare device states"

#: src/containers/Staff/StaffForm.tsx:60
msgid "Не удалось удалить данные о сотруднике"
msgstr "Couldn't delete staff data"

#: src/containers/Users/UserMenu.tsx:105
msgid "Не удалось удалить пользователя"
msgstr "Failed to delete user"

#: src/components/LastServiceDate/LastServiceDate.tsx:79
msgid "Не указана дата обслуживания"
msgstr "Maintenance date not specified"

#: src/containers/Users/NewUser.tsx:46
msgid "Неверный формат"
msgstr "Invalid format"

#: src/components/Stats/constants.ts:12
msgid "Неделя"
msgstr "Week"

#: src/containers/Services/Services.tsx:62
msgid "Недостаточно денежных средств для подключения данной услуги"
msgstr "Insufficient funds to connect this service"

#: src/containers/Terminals/BlockedByService/BlockedByService.tsx:5
msgid "Недостаточно средств для отображения списка устройств"
msgstr "Insufficient funds to display the list of devices"

#: src/ui-kit/Form/Switch/Switch.tsx:139
#: src/containers/Terminals/EditDevice/MainboardFields/options.ts:113
#: src/components/Switch.tsx:81
msgid "Нет"
msgstr "No"

#: src/containers/Migrations/Migrations.tsx:1268
msgid "Нет активной операции"
msgstr "No active operation"

#: src/containers/Terminals/Terminal/TerminalTitle.tsx:181
msgid "Нет аппаратов с таким адресом"
msgstr "There are no devices with this address."

#: src/ui-kit/Table/Table.tsx:234
msgid "Нет данных"
msgstr "No data"

#: src/containers/Migrations/Migrations.tsx:3767
msgid "Нет данных для визуализации"
msgstr "No data to visualize"

#: src/features/deviceAlerts/i18n/translations.ts:13
msgid "Нет платежей по каналу безналичная оплата (оплата банковской картой) более 2x часов"
msgstr "No payments by cashless channel (bank card payment) for more than 2 hours"

#: src/containers/Migrations/Migrations.tsx:3981
msgid "Нет рассчитанных пользователей для рейтинга"
msgstr "No estimated users available for ranking"

#: src/containers/Migrations/SystemMigrations.tsx:126
msgid "Нет связи"
msgstr "No connection"

#: src/containers/Terminals/EditDevice/EditDeviceTabs.tsx:97
msgid "Нет связи с платой водоподготовки"
msgstr "No connection with water preparing board"

#: src/containers/Terminals/EditDevice/EditDeviceTabs.tsx:82
msgid "Нет связи с платой управления"
msgstr "No connection with main board"

#: src/containers/Services/ChangeBalance.tsx:51
msgid "Новый баланс"
msgstr "New balance"

#: src/containers/Login/LoginForm.tsx:100
msgid "Новый пароль"
msgstr "New password"

#: src/containers/Dashboard/AllMoney/utils.ts:65
msgid "Новых устройств за период"
msgstr "New devices for the period"

#: src/containers/Dashboard/AllMoney/utils.ts:73
msgid "Новых устройств: оплачен App/QR"
msgstr "New devices: App/QR paid"

#: src/containers/Dashboard/AllMoney/utils.ts:69
msgid "Новых устройств: оплачен мониторинг"
msgstr "New devices: monitoring paid"

#: src/containers/Dashboard/AllMoney/utils.ts:77
msgid "Новых устройств: оплачен мониторинг + App/QR"
msgstr "New devices: monitoring + App/QR paid"

#: src/locales/constants.ts:15
msgid "Номер SIM"
msgstr "SIM number"

#: src/containers/Terminals/Terminal/DeviceState/TerminalBoard.tsx:112
msgid "Номер Техподдержки"
msgstr "Support phone number"

#: src/containers/Terminals/EditDevice/MainboardFields/options.ts:72
msgid "Номер Техподдержки в 1 строке"
msgstr "Technical Support number in 1 line"

#: src/containers/Migrations/Migrations.tsx:279
msgid "Нужен частичный пересчёт"
msgstr "Partial recalculation required"

#: src/containers/Migrations/Migrations.tsx:2980
msgid "Обновить"
msgstr "Refresh"

#: src/containers/Migrations/Migrations.tsx:2639
msgid "Обновлена схожесть аппаратов: {comparedCount}"
msgstr "Device similarity updated: {comparedCount}"

#: src/containers/Migrations/Migrations.tsx:1229
msgid "Обновление progress.txt"
msgstr "Updating progress.txt"

#: src/containers/Dashboard/AllMoney/AllMoney.tsx:120
msgid "Оборудование"
msgstr "Devices"

#: src/containers/Dashboard/BillingStats/columns.tsx:68
msgid "Обработано с ошибкой"
msgstr "Processed with errors"

#: src/containers/Terminals/EditDevice/PromoField.tsx:11
msgid "Обратите внимание, для корректной работы режима Промоакция параметр Автостоп наличные/банк.карта установлен равным 5 литров"
msgstr "Please note that for the correct operation of the Promo mode, the AUTOSTOP parameter is set to 5 liters."

#: src/components/BYNotification.tsx:26
msgid "Обращаем ваше внимание, что с 14.07.2026 для вендоров из Республики Беларусь техническая поддержка осуществляется ТОЛЬКО силами специалистов компании Живая Вода Россия. Телеграмм чат технической поддержки<0>@alivewaternewbot</0>"
msgstr "Please note that starting from 07/14/2026, technical support for vendors from the Republic of Belarus is provided ONLY by specialists from Zhivaya Voda Russia. Telegram technical support chat<0>@alivewaternewbot</0>"

#: src/containers/DeviceList/columns/list.tsx:84
#: src/containers/DeviceList/columns/desktop.tsx:220
msgid "Обслуживание"
msgstr "Service"

#: src/containers/Dashboard/Users/Users.tsx:47
msgid "Общая статистика"
msgstr "General statistics"

#: src/containers/Terminals/Terminal/DeviceState/DeviceState.tsx:62
msgid "Общее"
msgstr "Summary"

#: src/containers/Migrations/Migrations.tsx:3839
msgid "Общий объём"
msgstr "Total volume"

#: src/containers/Services/Recharge.tsx:66
msgid "Обязательное поле"
msgstr "Required field"

#: src/containers/Migrations/Migrations.tsx:3051
msgid "Ограничение записи PostgreSQL"
msgstr "PostgreSQL write limit"

#: src/containers/Migrations/Migrations.tsx:3000
msgid "Ограничение чтения DynamoDB"
msgstr "DynamoDB read limit"

#: src/containers/Migrations/SystemMigrations.tsx:102
#: src/containers/Migrations/Migrations.tsx:262
#: src/containers/Migrations/Migrations.tsx:280
msgid "Ожидает"
msgstr "Pending"

#: src/containers/Migrations/Migrations.tsx:2778
msgid "Ожидает запуска"
msgstr "Waiting to start"

#: src/containers/Migrations/Migrations.tsx:2966
msgid "Ожидают блокировки"
msgstr "Waiting for locks"

#: src/containers/Dashboard/Geography/Geography.tsx:26
msgid "Округа: {districtCount}"
msgstr "Districts: {districtCount}"

#: src/config/menu.tsx:117
msgid "ОМНИДЕСК-сообщения"
msgstr "Omnidesk-support"

#: src/containers/UserInfo/UserInfo.tsx:68
#: src/containers/Omnidesk/OmnuUser.tsx:20
msgid "Онлайн"
msgstr "Online"

#: src/containers/UserGroups/useUserGroupColumns.tsx:49
msgid "Описание"
msgstr "Description"

#: src/containers/Terminals/Terminal/DeviceState/TerminalSummary.tsx:145
msgid "Оплата через приложение"
msgstr "Payment via the app"

#: src/containers/Dashboard/Devices/utils.ts:64
msgid "Оплаченных"
msgstr "Paid"

#: src/containers/LowBalanceNotification/LowBalanceNotification.tsx:41
msgid "Оплачу позже"
msgstr "Pay later"

#: src/containers/Terminals/EditDevice/EditDeviceTabTitle.tsx:24
msgid "Оповещения"
msgstr "Notifications"

#: src/containers/Terminals/EditDevice/EditDeviceTabTitle.tsx:21
msgid "Основные настройки"
msgstr "Settings"

#: src/containers/Migrations/Migrations.tsx:3277
msgid "Осталось на миграцию, чч:мм:сс (прогноз ≈)"
msgstr "Migration time remaining, hh:mm:ss (forecast ≈)"

#: src/containers/Migrations/Migrations.tsx:3253
msgid "Осталось на оценку, чч:мм:сс (прогноз)"
msgstr "Time remaining for estimation, hh:mm:ss (forecast)"

#: src/containers/Migrations/SystemMigrations.tsx:128
#: src/containers/Migrations/Migrations.tsx:1171
msgid "Останавливается"
msgstr "Stopping"

#: src/containers/Migrations/Migrations.tsx:1182
msgid "Останавливается после пользователя"
msgstr "Stopping after user"

#: src/containers/Migrations/Migrations.tsx:1321
#: src/containers/Migrations/Migrations.tsx:1331
msgid "Останавливается…"
msgstr "Stopping…"

#: src/containers/Migrations/SystemMigrations.tsx:290
#: src/containers/Migrations/Migrations.tsx:1332
msgid "Остановить миграцию"
msgstr "Stop migration"

#: src/containers/Migrations/Migrations.tsx:1322
msgid "Остановить оценку"
msgstr "Stop estimation"

#: src/containers/Migrations/SystemMigrations.tsx:306
msgid "Остановка выполняется после текущей страницы или пакета. Уже перенесённые ключи остаются в Redis; готовый файл сохраняется в MinIO."
msgstr "Migration stops after the current page or batch. Keys already migrated remain in Redis; the completed file is saved to MinIO."

#: src/containers/Migrations/SystemMigrations.tsx:137
msgid "Остановка запрошена. Ожидаем завершения текущего пакета и сохранения готового файла."
msgstr "Stop requested. Waiting for the current batch to finish and the completed file to be saved."

#: src/containers/Migrations/Migrations.tsx:3146
msgid "Остановка оценки завершает текущего пользователя и не начинает следующего. Остановка миграции работает так же: текущий пользователь завершается полностью."
msgstr "Stopping estimation completes the current user and does not start the next one. Stopping migration works the same way: the current user is completed in full."

#: src/containers/Migrations/SystemMigrations.tsx:45
#: src/containers/Migrations/SystemMigrations.tsx:107
msgid "Остановлена"
msgstr "Stopped"

#: src/components/DeviceRemain.tsx:45
msgid "Остаток"
msgstr "Remaining water"

#: src/containers/Terminals/Terminal/DeviceState/TerminalSummary.tsx:172
msgid "Остаток воды"
msgstr "Remaining water"

#: src/components/DeviceRemain.tsx:27
msgid "Остаток скорректирован"
msgstr "Remaining water is adjusted"

#: src/containers/DeviceList/columns/desktop.tsx:70
msgid "Остаток тары"
msgstr "Bottles remain"

#: src/containers/Migrations/Migrations.tsx:1082
msgid "Открывает аппарат пользователя в Alivewater Cloud"
msgstr "Opens the user's device in Alivewater Cloud"

#: src/containers/Migrations/Migrations.tsx:1096
msgid "Открывает вкладку аппаратов с фильтром по этому пользователю"
msgstr "Opens the devices tab filtered by this user"

#: src/containers/Migrations/Migrations.tsx:1104
msgid "Открывает список аппаратов пользователя в Alivewater Cloud"
msgstr "Opens the user's devices in Alivewater Cloud"

#: src/containers/Migrations/Migrations.tsx:1080
msgid "Открыть аппарат на production-площадке"
msgstr "Open device on the production site"

#: src/containers/Migrations/Migrations.tsx:1102
msgid "Открыть на production-площадке"
msgstr "Open in production"

#: src/containers/SystemMaintenance/SystemMaintenance.tsx:88
msgid "Отмена"
msgstr "Cancel"

#: src/containers/Terminals/Terminal/DeviceState/MeterValue.tsx:112
#: src/containers/Staff/StaffForm.tsx:94
#: src/containers/Services/Recharge.tsx:113
msgid "Отменить"
msgstr "Cancel"

#: src/containers/Migrations/Migrations.tsx:3931
msgid "Относительно лидера"
msgstr "Relative to the leader"

#: src/containers/Migrations/DeviceStateComparisonModal.tsx:338
msgid "Отсутствует в PostgreSQL"
msgstr "Missing in PostgreSQL"

#: src/locales/constants.ts:51
msgid "Отчество"
msgstr "Middle name"

#. placeholder {0}: date ? t`за ${DateTime.fromMillis(Number(date)) .setLocale('ru-ru') .toFormat('dd-MM-yyyy')}` : null
#: src/containers/Report/Report.tsx:52
msgid "Отчет {user} {0}"
msgstr "Report {user} {0}"

#: src/containers/Dashboard/Devices/Devices.tsx:32
#: src/containers/Dashboard/AllMoney/AllMoney.tsx:71
msgid "Отчетный период:"
msgstr "Reporting period:"

#: src/containers/Users/UsersList.tsx:32
#: src/containers/UserInfo/UserInfo.tsx:68
#: src/containers/Omnidesk/OmnuUser.tsx:20
msgid "Оффлайн"
msgstr "Offline"

#: src/containers/Migrations/Migrations.tsx:3114
msgid "Оценка пользователей"
msgstr "User estimation"

#: src/containers/Migrations/Migrations.tsx:2058
msgid "Оценка пользователя завершена"
msgstr "User estimation completed"

#: src/containers/Migrations/Migrations.tsx:2878
msgid "Очередь Query"
msgstr "Query queue"

#: src/containers/Migrations/Migrations.tsx:3089
msgid "Очередь порций"
msgstr "Chunk queue"

#: src/containers/Migrations/SystemMigrations.tsx:43
#: src/containers/Migrations/SystemMigrations.tsx:105
#: src/containers/Migrations/Migrations.tsx:266
#: src/containers/Migrations/Migrations.tsx:283
#: src/containers/Dashboard/BillingStats/BillingLogs.tsx:24
msgid "Ошибка"
msgstr "Error"

#: src/contexts/UserContext/UserContext.tsx:72
msgid "Ошибка авторизации"
msgstr "Auth error"

#: src/containers/Terminals/EditDevice/EditDevice.tsx:130
msgid "Ошибка активации аппарата"
msgstr "Terminal activation has error"

#: src/containers/Login/LoginForm.tsx:54
msgid "Ошибка восстановления пароля"
msgstr "Password recovery error"

#: src/contexts/UserContext/UserContext.tsx:277
msgid "Ошибка входа"
msgstr "Login error"

#: src/containers/Migrations/SystemMigrations.tsx:220
msgid "Ошибка выгрузки"
msgstr "Export failed"

#: src/containers/Terminals/Terminal/ResetDevice.tsx:31
msgid "Ошибка выполнения операции"
msgstr "Operation error"

#: src/containers/Migrations/SystemMigrations.tsx:225
msgid "Ошибка записи в Redis"
msgstr "Redis write failed"

#: src/features/deviceAlerts/i18n/translations.ts:18
msgid "Ошибка купюроприемника"
msgstr "Bill acceptor error"

#: src/containers/Migrations/Migrations.tsx:741
#: src/containers/Migrations/Migrations.tsx:1037
msgid "Ошибка миграции"
msgstr "Migration error"

#: src/features/deviceAlerts/i18n/translations.ts:19
msgid "Ошибка монетоприемника"
msgstr "Coin Error"

#: src/containers/Terminals/EditDevice/EditDevice.tsx:90
msgid "Ошибка операции"
msgstr "Operation error"

#: src/containers/Migrations/Migrations.tsx:723
#: src/containers/Migrations/Migrations.tsx:1018
msgid "Ошибка оценки"
msgstr "Estimate error"

#: src/contexts/UserContext/UserContext.tsx:306
msgid "Ошибка сброса пароля"
msgstr "Password reset error"

#: src/containers/Migrations/SystemMigrations.tsx:215
msgid "Ошибка сохранения состояния в PostgreSQL"
msgstr "Failed to save state to PostgreSQL"

#: src/features/deviceAlerts/i18n/translations.ts:17
msgid "Ошибка фискального сервера"
msgstr "Fiscal server error"

#: src/containers/Migrations/Migrations.tsx:2832
msgid "Память pod: свободно / всего"
msgstr "Pod memory: free / total"

#: src/containers/Migrations/Migrations.tsx:2750
msgid "Панель управления миграцией"
msgstr "Migration control panel"

#: src/containers/Migrations/Migrations.tsx:3065
msgid "Параллельные подключения COPY"
msgstr "Parallel COPY connections"

#: src/locales/constants.ts:52
#: src/containers/Terminals/EditDevice/WifiFields.tsx:54
#: src/containers/Login/LoginForm.tsx:86
msgid "Пароль"
msgstr "Password"

#: src/containers/Users/UserMenu.tsx:143
msgid "Пароль пользователя<0>{Username}</0>будет сброшен. На адрес {Email} будет отправлен код восстановления."
msgstr "The user's password<0>{Username}</0> will be reset. A recovery code will be sent to {Email}."

#: src/locales/constants.ts:60
msgid "Перевод отсутствует"
msgstr ".................."

#: src/containers/Terminals/Terminal/ResetDevice.tsx:40
msgid "Перезагрузить плату управления"
msgstr "Reset control board"

#: src/containers/LowBalanceNotification/LowBalanceNotification.tsx:40
msgid "Перейти к оплате"
msgstr "Proceed to payment"

#: src/containers/Terminals/EditDevice/BundleDeviceInfo.tsx:107
msgid "Перейти на редактирование вторичного устройства"
msgstr "Go to edit secondary device"

#: src/containers/Migrations/Migrations.tsx:1071
msgid "Перенести данные пользователя"
msgstr "Migrate user data"

#: src/containers/Migrations/SystemMigrations.tsx:169
msgid "Перенос общих данных, не привязанных к пользователям и аппаратам."
msgstr "Migration of shared data not linked to individual users or devices."

#: src/components/CartridgeValue/EditValueModal.tsx:106
msgid "Пересчитать"
msgstr "Recalculate"

#: src/components/CartridgeValue/EditValueModal.tsx:105
msgid "Пересчитать ресурс фильтров?"
msgstr "Recalculate filter resource?"

#: src/containers/Sales/Sales.tsx:133
#: src/containers/Encash/Encash.tsx:88
#: src/components/Stats/Stats.tsx:144
msgid "Период"
msgstr "Range"

#: src/containers/Services/BalanceHistory.tsx:110
msgid "Период:"
msgstr "Period:"

#: src/containers/Terminals/EditDevice/AcidWashFields.tsx:154
msgid "Периодичность запуска промывки ХВС {pflUnit}"
msgstr "The frequency of starting the cold-water washing"

#: src/containers/Terminals/EditDevice/AcidWashFields.tsx:123
msgid "Периодичность промывки"
msgstr "Frequency of washing"

#: src/containers/Terminals/Terminal/DeviceState/DeviceState.tsx:82
#: src/containers/Terminals/EditDevice/EditDeviceTabTitle.tsx:22
msgid "Плата управления"
msgstr "Control board"

#: src/containers/Terminals/Terminal/ResetDevice.tsx:26
msgid "Плата управления будет перезагружена"
msgstr "Control board will be reset"

#: src/containers/Dashboard/AllMoney/utils.ts:9
msgid "Платежи от ckassa"
msgstr "Payments from ckassa"

#: src/containers/Dashboard/AllMoney/utils.ts:14
msgid "Платежными поручениями"
msgstr "Payment orders"

#: src/containers/DeviceList/constants.ts:15
msgid "по адресу"
msgstr "by address"

#: src/containers/DeviceList/AuditTab/AuditTab.tsx:215
msgid "по адресу аппарата"
msgstr "by device address"

#: src/containers/DeviceList/constants.ts:14
msgid "по дате первого запуска"
msgstr "by first launch date"

#: src/containers/Terminals/EditDevice/DeviceAdditionalFields.tsx:39
msgid "По закату и рассвету (только Россия)"
msgstr "By sunset and sunrise (Russia only)"

#: src/containers/Migrations/Migrations.tsx:3688
msgid "По оси X — количество аппаратов у пользователя, по оси Y — количество пользователей."
msgstr "The X-axis shows devices per user; the Y-axis shows the number of users."

#: src/containers/DeviceList/constants.ts:19
msgid "по предупреждениям"
msgstr "by alerts"

#: src/containers/DeviceList/constants.ts:16
msgid "по примечанию"
msgstr "by note"

#: src/containers/Terminals/EditDevice/DeviceAdditionalFields.tsx:32
msgid "По расписанию"
msgstr "By schedule"

#: src/containers/DeviceList/constants.ts:17
msgid "по сумме всего"
msgstr "by total amount"

#: src/containers/DeviceList/constants.ts:18
msgid "по сумме за день"
msgstr "by daily amount"

#: src/containers/Migrations/SystemMigrations.tsx:179
msgid "Повторить"
msgstr "Retry"

#: src/containers/Migrations/Migrations.tsx:1211
msgid "Подготовка временного каталога"
msgstr "Preparing temporary directory"

#: src/containers/Migrations/Migrations.tsx:1209
msgid "Подготовка списка аппаратов"
msgstr "Preparing device list"

#: src/containers/Services/Services.tsx:68
msgid "Подключена"
msgstr "Connected"

#: src/containers/Terminals/Terminal/DeviceState/TerminalSummary.tsx:149
msgid "Подсветка"
msgstr "Backlight"

#: src/containers/DeviceList/DeviceList.tsx:309
msgid "Подсветка оповещений"
msgstr "Highlight alerts"

#: src/containers/Dashboard/Users/Users.tsx:79
msgid "Подтвержденных"
msgstr "Confirmed"

#: src/containers/Dashboard/Users/Users.tsx:53
msgid "Подтвержденных:"
msgstr "Confirmed:"

#: src/containers/SystemMaintenance/MaintenancePage.tsx:16
msgid "Пожалуйста, попробуйте выполнить операцию позже."
msgstr "Please try the operation again later."

#: src/containers/Migrations/Migrations.tsx:3612
msgid "Поиск по Device ID или User ID"
msgstr "Search by Device ID or User ID"

#: src/containers/Migrations/Migrations.tsx:3412
msgid "Поиск по логину или User ID"
msgstr "Search by username or User ID"

#: src/containers/DeviceList/columns/desktop.tsx:119
msgid "Показания"
msgstr "Indications"

#: src/containers/Migrations/Migrations.tsx:3391
msgid "Показать аппараты выбранных пользователей"
msgstr "Show devices of selected users"

#: src/containers/Migrations/Migrations.tsx:1094
msgid "Показать аппараты пользователя"
msgstr "Show user devices"

#: src/containers/Terminals/Terminal/DeviceLogs/DeviceLogs.tsx:151
msgid "Показать данные без форматирования"
msgstr "Show data without formatting"

#: src/containers/Migrations/Migrations.tsx:1188
msgid "Показать пользователя в таблице"
msgstr "Show user in table"

#: src/containers/Migrations/Migrations.tsx:3428
msgid "Показать удаленных"
msgstr "Show deleted"

#: src/containers/Migrations/Migrations.tsx:1088
msgid "Показывает различия между состояниями аппарата в DynamoDB и PostgreSQL"
msgstr "Shows differences between the device states in DynamoDB and PostgreSQL"

#: src/components/ui/Pagination.tsx:56
msgid "Показывать{limitsSelect}записей"
msgstr "Show{limitsSelect}records"

#: src/locales/constants.ts:17
msgid "Поле примечание выводится в 5 строке экрана \"Аппараты\" в столбце Адрес. В этом поле вы можете указать дополнительную информацию к адресу установки. По этому полю так же возможно отсортировать аппараты."
msgstr "The note field is displayed in line 5 of the \"Devices\" screen in the Address column. In this field, you can specify additional information to the installation address. It is also possible to sort the devices by this field."

#: src/containers/Migrations/Migrations.tsx:1067
msgid "Получает количество данных пользователя из DynamoDB"
msgstr "Retrieves the user's data counts from DynamoDB"

#: src/containers/Migrations/Migrations.tsx:3754
msgid "Пользователей"
msgstr "Users"

#: src/containers/Migrations/Migrations.tsx:3215
msgid "Пользователей с рассчитанными метриками"
msgstr "Users with calculated metrics"

#: src/containers/Users/Users.tsx:25
#: src/containers/Migrations/Migrations.tsx:3307
#: src/containers/Dashboard/Dashboard.tsx:34
#: src/config/menu.tsx:42
msgid "Пользователи"
msgstr "Users"

#: src/containers/Migrations/Migrations.tsx:3890
msgid "Пользователи с наибольшим количеством продаж или записей телеметрии."
msgstr "Users with the highest number of sales or telemetry records."

#: src/containers/Migrations/Migrations.tsx:3915
#: src/containers/Dashboard/BillingStats/BillingLogs.tsx:19
msgid "Пользователь"
msgstr "User"

#: src/containers/Users/UserMenu.tsx:168
msgid "Пользователь <0>{Username}</0> будет заблокирован. Он не сможет авторизоваться в личном кабинете."
msgstr "The user <0>{Username}</0> will be blocked. He will not be able to log in to his personal account."

#: src/containers/Users/UserMenu.tsx:119
msgid "Пользователь <0>{Username}</0> будет удален безвозвратно."
msgstr "The user <0>{Username}</0> will be permanently deleted."

#: src/components/ConnectBot/ConnectMaxBot.tsx:170
msgid "Пользователь Max успешно отвязан"
msgstr "Max user successfully disconnected"

#: src/containers/Users/UserMenu.tsx:91
msgid "Пользователь заблокирован"
msgstr "User was blocked"

#: src/containers/Users/UserMenu.tsx:92
msgid "Пользователь разблокирован"
msgstr "User was unblocked"

#: src/containers/Users/NewUser.tsx:73
msgid "Пользователь создан. Данные отправлены на {Email}"
msgstr "The user has been created. The data has been sent to {Email}"

#: src/containers/Users/UserMenu.tsx:103
msgid "Пользователь удален"
msgstr "User was deleted"

#: src/containers/Migrations/Migrations.tsx:824
msgid "Пользователь удалён из DynamoDB"
msgstr "User has been deleted from DynamoDB"

#: src/containers/Users/NewUser.tsx:79
msgid "Пользователь уже существует"
msgstr "The user already exists"

#: src/containers/UserInfo/UserInfo.tsx:71
msgid "Пользователь:"
msgstr "User:"

#: src/containers/Terminals/EditDevice/BundleDeviceInfo.tsx:25
#: src/components/ServiceNotificationModal.tsx:33
msgid "Понятно"
msgstr "Ok"

#: src/containers/Services/Recharge.tsx:112
#: src/containers/Sales/DeviceIncome.tsx:59
msgid "Пополнить"
msgstr "Top up"

#: src/containers/Services/Recharge.tsx:106
#: src/containers/Services/Recharge.tsx:109
#: src/containers/Sales/DeviceIncome.tsx:90
msgid "Пополнить баланс"
msgstr "Top up balance"

#: src/containers/Sales/DeviceIncome.tsx:86
msgid "Пополнить баланс клиенту на аппарате"
msgstr "Top up client balance"

#: src/containers/UserInfo/UserInfo.tsx:78
msgid "Последний визит:"
msgstr "Last visit:"

#: src/locales/constants.ts:50
msgid "Последний вход"
msgstr "Last visit date"

#: src/containers/DeviceList/columns/mobile.tsx:309
#: src/containers/DeviceList/columns/desktop.tsx:168
msgid "Последний выход на связь"
msgstr "Last contact"

#: src/containers/Migrations/Migrations.tsx:3575
msgid "Последнюю инкассацию"
msgstr "Latest collection"

#: src/containers/Terminals/Terminal/DeviceState/TerminalFinState.tsx:94
#: src/containers/Migrations/Migrations.tsx:2597
msgid "Последняя инкассация"
msgstr "Last encash"

#: src/containers/Terminals/Terminal/DeviceState/TerminalFinState.tsx:110
#: src/containers/DeviceList/columns/mobile.tsx:324
#: src/containers/DeviceList/columns/desktop.tsx:183
msgid "Последняя продажа"
msgstr "Last sale"

#: src/containers/Sales/useSalesColumns.tsx:123
msgid "Потенциально фишинговая продажа"
msgstr "Potentially phishing sale"

#: src/features/deviceAlerts/components/DeviceAlerts.tsx:31
msgid "Предупреждений не обнаружено"
msgstr "No alerts"

#: src/containers/Terminals/Terminal/DeviceState/DeviceState.tsx:98
#: src/containers/DeviceList/columns/base.tsx:20
msgid "Предупреждения"
msgstr "Alerts"

#: src/containers/Migrations/Migrations.tsx:747
msgid "Предыдущий User ID"
msgstr "Previous User ID"

#: src/containers/Migrations/SystemMigrations.tsx:44
msgid "Прервано"
msgstr "Interrupted"

#: src/containers/Terminals/Terminal/DeviceState/DeviceState.tsx:91
#: src/containers/DeviceList/constants.ts:25
msgid "Приборы"
msgstr "Units"

#: src/locales/constants.ts:16
#: src/containers/DeviceList/columns/list.tsx:115
msgid "Примечание"
msgstr "Note"

#: src/containers/Dashboard/BillingStats/columns.tsx:47
msgid "Прогноз завершения"
msgstr "Estimate time"

#: src/features/salesDynamics/ui/SalesDynamicsTotal.tsx:48
#: src/containers/DeviceList/columns/salesDynamicsColumns.tsx:23
msgid "Прогноз на {month}"
msgstr "Forecast {month}"

#: src/containers/Terminals/Terminal/DeviceState/TerminalSummary.tsx:176
msgid "Прогноз остатка на конец текущих суток"
msgstr "Balance forecast for the end of the current day"

#: src/containers/Migrations/Migrations.tsx:3280
msgid "Прогноз рассчитан по сумме времени обработки пользователей. Этапы конвейера выполняются параллельно, поэтому фактическое оставшееся календарное время может быть меньше прогноза."
msgstr "The forecast is based on the sum of user processing times. Pipeline stages run in parallel, so the actual remaining elapsed time may be shorter than forecast."

#: src/containers/Dashboard/BillingStats/columns.tsx:42
msgid "Прогресс"
msgstr "Progress"

#: src/containers/Migrations/Migrations.tsx:3925
msgid "Продаж"
msgstr "Sales"

#: src/containers/Terminals/Terminal/Device.tsx:98
#: src/containers/Migrations/Migrations.tsx:647
#: src/containers/Migrations/Migrations.tsx:934
#: src/containers/Migrations/Migrations.tsx:3811
#: src/containers/Migrations/Migrations.tsx:3899
#: src/config/menu.tsx:60
msgid "Продажи"
msgstr "Sales"

#: src/containers/Migrations/Migrations.tsx:3778
msgid "Продажи, инкассации и события учитываются полностью. В альтернативных сценариях уменьшается только объединённая телеметрия."
msgstr "Sales, cash collections, and events are included in full. Only combined telemetry is reduced in alternative scenarios."

#: src/containers/Migrations/Migrations.tsx:394
#: src/containers/Dashboard/BillingStats/columns.tsx:52
msgid "Продолжительность"
msgstr "Time spent"

#: src/containers/Users/UserMenu.tsx:125
#: src/containers/Users/UserMenu.tsx:151
#: src/containers/Users/UserMenu.tsx:174
msgid "Продолжить?"
msgstr "Continue?"

#: src/config/menu.tsx:105
msgid "Проект Оракул"
msgstr "Oracle Project"

#: src/containers/Terminals/EditDevice/AcidWashFields.tsx:18
msgid "Промывка ежедневно"
msgstr "Daily washing"

#: src/containers/Terminals/EditDevice/AcidWashFields.tsx:14
msgid "Промывка отключена"
msgstr "Washing disabled"

#: src/containers/Terminals/EditDevice/AcidWashFields.tsx:26
msgid "Промывка через два дня"
msgstr "Washing after two days"

#: src/containers/Terminals/EditDevice/AcidWashFields.tsx:22
msgid "Промывка через день"
msgstr "Washing after one day"

#: src/containers/Migrations/SystemMigrations.tsx:106
msgid "Пропущен"
msgstr "Skipped"

#: src/containers/Migrations/Migrations.tsx:2561
msgid "Пропущено выполняющихся миграций: {skippedCount}"
msgstr "Running migrations skipped: {skippedCount}"

#: src/containers/Migrations/SystemMigrations.tsx:210
msgid "Пропущено истёкших"
msgstr "Expired records skipped"

#: src/containers/UserInfo/UserInfo.tsx:94
#: src/containers/Profile/EditProfile.tsx:62
msgid "Профиль"
msgstr "Profile"

#: src/containers/Profile/EditProfile.tsx:53
msgid "Профиль обновлен"
msgstr "Profile is updated"

#: src/containers/Sales/SalesTotal.tsx:137
msgid "Процент конвертации (за текущие сутки): {conversion}"
msgstr "Conversion percentage (for the current day): {conversion}"

#: src/config/menu.tsx:87
msgid "Прошивка оборудования"
msgstr "Equipment firmware"

#: src/containers/Terminals/Terminal/DeviceState/TerminalSummary.tsx:71
msgid "Прошивка платы управления"
msgstr "Firmware of the control board"

#: src/containers/Users/UserMenu.tsx:215
msgid "Разблокировать"
msgstr "Unblock"

#: src/containers/Migrations/Migrations.tsx:2883
msgid "Размер страницы Query"
msgstr "Query page size"

#: src/containers/Migrations/DeviceStateComparisonModal.tsx:347
msgid "Разница"
msgstr "Difference"

#: src/containers/OraclePage/ComputeTab/utils.ts:110
msgid "Разовые расходы в выбранный период отсутствуют"
msgstr "One-time expenses for the selected period are not available"

#: src/containers/Terminals/Terminal/DeviceState/TerminalSummary.tsx:164
msgid "Разрешить водоподготовку"
msgstr "Allow water preparing"

#: src/locales/constants.ts:20
msgid "Разрешить продажу минеральной воды"
msgstr "Allow the sale of mineral water"

#: src/containers/Terminals/Terminal/Device.tsx:109
msgid "Расписание"
msgstr "Schedule"

#: src/containers/Migrations/Migrations.tsx:3683
msgid "Распределение пользователей по количеству аппаратов"
msgstr "Distribution of users by device count"

#: src/containers/Migrations/Migrations.tsx:1065
msgid "Рассчитать метрики пользователя"
msgstr "Estimate user metrics"

#: src/containers/Migrations/Migrations.tsx:3590
msgid "Рассчитать схожесть"
msgstr "Calculate similarity"

#: src/containers/Services/Services.tsx:209
#: src/containers/DeviceList/columns/mobile.tsx:358
#: src/containers/DeviceList/columns/desktop.tsx:206
msgid "Расход"
msgstr "Consumption"

#. placeholder {0}: convertTimestampToLocalDateString( data.period.fromTs )
#. placeholder {1}: convertTimestampToLocalDateString( data.period.toTs )
#: src/containers/OraclePage/ComputeTab/utils.ts:228
msgid "Расходы для терминала были посчитаны за период с {0} по {1} (когда были продажи)."
msgstr "Expenses for the terminal were calculated for the period from {0} to {1} (when there were sales)."

#: src/containers/Dashboard/Geography/Geography.tsx:30
msgid "Регионы: {regionCount}"
msgstr "Regions: {regionCount}"

#: src/containers/Terminals/EditDevice/EditDevice.tsx:158
msgid "Редактирование аппарата"
msgstr "Edit device"

#: src/containers/Encash/EncashComment.tsx:49
msgid "Редактирование комментария"
msgstr "Edit comment"

#: src/containers/Users/UserMenu.tsx:204
#: src/containers/Staff/StaffForm.tsx:84
msgid "Редактировать"
msgstr "Edit"

#: src/containers/Terminals/Terminal/DeviceState/TerminalSummary.tsx:160
msgid "Режим “Промоакция”"
msgstr "The “Promotion” mode"

#: src/components/CartridgeValue/EditValueModal.tsx:91
msgid "Ресурс фильтров успешно обновлен"
msgstr "Cartridge resource updated successfully"

#: src/locales/constants.ts:54
msgid "Роль"
msgstr "Role"

#: src/containers/Dashboard/AllMoney/utils.ts:24
msgid "Ручная корректировка"
msgstr "Manual adjustment"

#: src/containers/Dashboard/AllMoney/utils.ts:47
msgid "Ручные корректировки"
msgstr "Manual adjustments"

#: src/containers/Migrations/formatDuration.tsx:30
#: src/containers/Migrations/DeviceStateComparisonModal.tsx:388
msgid "с"
msgstr "s"

#: src/features/serviceNotification/ServiceNotification.tsx:26
msgid "С 22:00 13 октября (МСК) по 01:00 14 октября (МСК), на коммуникационном оборудовании запланированы профилактические работы. В это время может наблюдаться недоступность системы GSM мониторинга и/или задержки в получении данных телеметрии от водоматов. Суммарное время перерыва составит не более 30 минут. Приносим извинения за доставленные неудобства."
msgstr "From 22:00 on October 13 (Moscow time) to 01:00 on October 14 (Moscow time), preventive maintenance is planned on the communication equipment. At this time, there may be unavailability of the GSM monitoring system and/or delays in receiving telemetry data from water meters. The total break time will be no more than 30 minutes. We apologize for any inconvenience caused."

#: src/containers/Migrations/Migrations.tsx:3204
msgid "с аппаратами"
msgstr "with devices"

#: src/containers/Users/UserMenu.tsx:139
#: src/components/CartridgeValue/ResetButton.tsx:22
msgid "Сбросить"
msgstr "Reset"

#: src/containers/Users/UserMenu.tsx:208
msgid "Сбросить пароль"
msgstr "Reset password"

#: src/containers/Users/UserMenu.tsx:138
msgid "Сбросить пароль пользователя?"
msgstr "Reset the user's password?"

#: src/containers/Migrations/Migrations.tsx:3426
#: src/containers/Migrations/Migrations.tsx:3630
msgid "Сбросить фильтр"
msgstr "Reset filter"

#: src/containers/Migrations/Migrations.tsx:1299
msgid "Свободен"
msgstr "Available"

#: src/containers/Migrations/Migrations.tsx:2771
msgid "Сервис"
msgstr "Service"

#: src/containers/Migrations/Migrations.tsx:1219
msgid "Синхронизация счётчиков telemetry в Redis"
msgstr "Synchronizing telemetry counters in Redis"

#: src/containers/Migrations/Migrations.tsx:3500
msgid "Синхронизировать аппараты"
msgstr "Synchronize devices"

#: src/containers/Migrations/Migrations.tsx:3318
msgid "Синхронизировать пользователей"
msgstr "Synchronize users"

#: src/containers/Migrations/Migrations.tsx:3988
msgid "Системные данные"
msgstr "System data"

#: src/containers/Profile/EditProfile.tsx:92
msgid "Смена пароля"
msgstr "Change password"

#: src/containers/Migrations/Migrations.tsx:3514
msgid "Сменили владельца: {reassignedDeviceCount}"
msgstr "Devices reassigned: {reassignedDeviceCount}"

#: src/containers/Terminals/Terminal/DeviceLogs/DeviceLogs.tsx:101
msgid "Событие"
msgstr "Event"

#: src/containers/Migrations/Migrations.tsx:658
#: src/containers/Migrations/Migrations.tsx:946
#: src/containers/Migrations/Migrations.tsx:3813
msgid "События"
msgstr "Events"

#: src/containers/Migrations/DeviceStateComparisonModal.tsx:328
msgid "Совпадение строк"
msgstr "Matching lines"

#: src/containers/Migrations/Migrations.tsx:2955
msgid "Соединения: активные / всего"
msgstr "Connections: active / total"

#: src/containers/DeviceList/AuditTab/AuditTab.tsx:210
msgid "Сортировать по дате"
msgstr "Sort by date"

#: src/containers/Migrations/Migrations.tsx:3775
msgid "Состав переносимых данных"
msgstr "Migrated data composition"

#: src/containers/Terminals/Terminal/Device.tsx:94
#: src/containers/Migrations/SystemMigrations.tsx:214
msgid "Состояние"
msgstr "State"

#: src/containers/Terminals/Terminal/DeviceState/BotlerStatus.tsx:33
msgid "Состояние бутылочника"
msgstr "Bottler state"

#: src/containers/Migrations/Migrations.tsx:2638
msgid "Состояния аппаратов сравнены"
msgstr "Device states compared"

#: src/containers/Omnidesk/Omnidesk.tsx:36
msgid "Сотрудник"
msgstr "Employee"

#: src/config/menu.tsx:124
msgid "Сотрудники"
msgstr "Staff"

#: src/containers/Migrations/SystemMigrations.tsx:50
msgid "Сохранение в MinIO"
msgstr "Saving to MinIO"

#: src/containers/Migrations/Migrations.tsx:1225
msgid "Сохранение резервной копии в MinIO"
msgstr "Saving backup to MinIO"

#: src/containers/Terminals/Terminal/DeviceState/MeterValue.tsx:109
#: src/components/DeviceRemain.tsx:48
#: src/components/LastServiceDate/LastServiceDate.tsx:170
#: src/components/EditAuditComment/EditAuditCommentModal.tsx:77
msgid "Сохранить"
msgstr "Save"

#: src/features/deviceAlerts/i18n/translations.ts:16
msgid "Сработал датчик малого уровня воды в баке"
msgstr "Low water level sensor in the tank has triggered"

#: src/features/deviceAlerts/i18n/translations.ts:10
msgid "Сработал датчик низкого давления"
msgstr "Low pressure sensor triggered"

#: src/features/deviceAlerts/i18n/translations.ts:11
msgid "Сработал датчик открытия двери"
msgstr "Door open sensor triggered"

#: src/containers/Migrations/Migrations.tsx:2644
msgid "Сравнение аппаратов завершено с ошибками"
msgstr "Device comparison completed with errors"

#: src/containers/Migrations/DeviceStateComparisonModal.tsx:303
msgid "Сравнение состояний аппарата"
msgstr "Device state comparison"

#: src/containers/Migrations/Migrations.tsx:2647
msgid "Сравнено: {comparedCount}, ошибок: {failedCount}"
msgstr "Compared: {comparedCount}, errors: {failedCount}"

#: src/containers/Migrations/Migrations.tsx:2646
msgid "Сравнено: {comparedCount}, ошибок: {failedCount}. Первая ошибка: {deviceId}: {failureMessage}"
msgstr "Compared: {comparedCount}, errors: {failedCount}. First error: {deviceId}: {failureMessage}"

#: src/containers/Migrations/Migrations.tsx:1086
msgid "Сравнить состояния аппарата"
msgstr "Compare device states"

#: src/containers/Sales/DeviceIncome.tsx:30
msgid "Средства зачислены"
msgstr "Funds credited"

#: src/components/ConnectBot/ConnectMaxBot.tsx:106
#: src/components/ConnectBot/ConnectMaxBot.tsx:120
#: src/components/ConnectBot/ConnectBot.tsx:108
#: src/components/ConnectBot/ConnectBot.tsx:127
msgid "Ссылка скопирована в буфер обмена"
msgstr "Link copied to clipboard"

#: src/containers/UserInfo/UserInfo.tsx:91
#: src/containers/Terminals/Terminal/DeviceState/DeviceState.tsx:104
msgid "Статистика"
msgstr "Statistics"

#: src/containers/Dashboard/Users/Users.tsx:62
msgid "Статистика по месяцам"
msgstr "Statistics by months"

#: src/locales/constants.ts:55
#: src/containers/Migrations/SystemMigrations.tsx:268
#: src/containers/Migrations/Migrations.tsx:2774
msgid "Статус"
msgstr "Status"

#: src/containers/Migrations/Migrations.tsx:642
#: src/containers/Migrations/Migrations.tsx:913
msgid "Статус миграции"
msgstr "Migration status"

#: src/containers/Migrations/Migrations.tsx:2560
#: src/containers/Migrations/Migrations.tsx:2565
msgid "Статус миграции изменён: {updatedCount}"
msgstr "Migration status changed: {updatedCount}"

#: src/containers/Migrations/SystemMigrations.tsx:134
msgid "Статус недоступен; данные могут быть устаревшими"
msgstr "Status unavailable; data may be outdated"

#: src/containers/Migrations/Migrations.tsx:637
#: src/containers/Migrations/Migrations.tsx:902
#: src/containers/Migrations/Migrations.tsx:2781
msgid "Статус оценки"
msgstr "Estimate status"

#: src/features/uvLampStatus/components/UVLampStatusSwitch.tsx:7
msgid "Статус УФ лампы"
msgstr "UV lamp status"

#: src/containers/SystemMaintenance/SystemMaintenance.tsx:42
msgid "Статус шторки"
msgstr "Maintenance status"

#: src/containers/SystemMaintenance/SystemMaintenance.tsx:125
msgid "Статусы worker pod'ов"
msgstr "Worker pod statuses"

#: src/containers/Terminals/Terminal/DeviceState/TerminalFinState.tsx:58
msgid "Стоимость литра"
msgstr "Price per liter"

#: src/containers/UserGroups/useUserGroupColumns.tsx:35
msgid "Страна"
msgstr "Country"

#: src/containers/Dashboard/Geography/Geography.tsx:24
msgid "Страны"
msgstr "Countries"

#: src/containers/DeviceList/columns/filtersColumns.tsx:23
msgid "Ступени очистки <0/>"
msgstr "Purification stages <0/>"

#: src/containers/Services/BalanceHistory.tsx:32
msgid "Сумма"
msgstr "Amount"

#: src/containers/Services/Recharge.tsx:155
msgid "Сумма в рублях"
msgstr "Amount"

#. placeholder {0}: formatMoney(data.income, currency)
#: src/containers/OraclePage/ComputeTab/utils.ts:244
msgid "Суммарная выручка = {0}"
msgstr "Total revenue = {0}"

#: src/features/salesDynamics/ui/SalesDynamicsTotal.tsx:40
msgid "Суммарная динамика продаж"
msgstr "Total sales dynamics"

#. placeholder {0}: formatMoney(data.profit, currency)
#: src/containers/OraclePage/ComputeTab/utils.ts:245
msgid "Суммарная прибыль = {0}"
msgstr "Total profit = {0}"

#. placeholder {0}: formatMoney(data.expenses, currency)
#: src/containers/OraclePage/ComputeTab/utils.ts:242
msgid "Суммарные операционные расходы = {0}"
msgstr "Total operating expenses = {0}"

#: src/containers/Migrations/Migrations.tsx:632
msgid "Схожесть"
msgstr "Similarity"

#: src/containers/Terminals/Terminal/DeviceState/MeterValue.tsx:20
msgid "Счетчик ХВС"
msgstr "Incoming water meter"

#: src/containers/Terminals/Terminal/DeviceState/MeterValue.tsx:19
msgid "Счетчик Электроэнергии"
msgstr "Electric energy meter"

#: src/containers/Migrations/Migrations.tsx:3092
msgid "Текущая таблица"
msgstr "Current table"

#: src/containers/Migrations/Migrations.tsx:2860
msgid "Текущее потребление"
msgstr "Current consumption"

#: src/containers/Migrations/Migrations.tsx:3014
msgid "Текущий лимит"
msgstr "Current limit"

#: src/newComponents/Faq/Faq.tsx:55
msgid "Телеграмм чат технической поддержки <0>@alivewaternewbot</0>"
msgstr "Telegram technical support chat <0>@alivewaternewbot</0>"

#: src/containers/Migrations/Migrations.tsx:3927
msgid "Телеметрии"
msgstr "Telemetry"

#: src/containers/Migrations/Migrations.tsx:3814
#: src/containers/Migrations/Migrations.tsx:3900
msgid "Телеметрия"
msgstr "Telemetry"

#: src/containers/Migrations/Migrations.tsx:3808
msgid "Телеметрия ÷ 10"
msgstr "Telemetry ÷ 10"

#: src/containers/Migrations/Migrations.tsx:3807
msgid "Телеметрия ÷ 5"
msgstr "Telemetry ÷ 5"

#: src/locales/constants.ts:53
msgid "Телефон"
msgstr "Phone"

#: src/locales/constants.ts:18
msgid "Телефон поддержки"
msgstr "Support phone number"

#: src/containers/Terminals/EditDevice/MainboardFields/MainboardFields.tsx:21
#: src/containers/Terminals/EditDevice/MainboardFields/MainboardFields.tsx:33
msgid "Температура включения больше или равна температуре выключения"
msgstr "Activation temperature is greater than or equal to deactivation temperature"

#: src/containers/Terminals/EditDevice/MainboardFields/MainboardFields.tsx:27
#: src/containers/Terminals/EditDevice/MainboardFields/MainboardFields.tsx:39
msgid "Температура выключения меньше или равна температуре включения"
msgstr "Deactivation temperature is less than or equal to activation temperature"

#. placeholder {0}: data.address
#: src/containers/OraclePage/ComputeTab/utils.ts:212
msgid "Терминал по адресу {0}"
msgstr "Terminal at {0}"

#: src/containers/Main/Main.tsx:79
msgid "Техническая поддержка<0/>с 07: 00 до 21: 00 МСК"
msgstr "Help desk<0/>from 07: 00 to 21: 00 Moscow time"

#: src/containers/SystemMaintenance/SystemMaintenance.tsx:98
#: src/config/menu.tsx:130
msgid "Технические работы"
msgstr "Maintenance"

#: src/containers/SystemMaintenance/SystemMaintenance.tsx:106
msgid "Технические работы (aka \"шторка\")"
msgstr "Maintenance (aka \"curtain\")"

#: src/components/Stats/constants.ts:19
msgid "Тип воды"
msgstr "Water type"

#: src/containers/Migrations/SystemMigrations.tsx:263
msgid "Тип миграции"
msgstr "Migration type"

#: src/containers/Migrations/Migrations.tsx:3887
msgid "Топ-20 пользователей"
msgstr "Top 20 users"

#: src/locales/constants.ts:6
msgid "Точный адрес установки аппарата"
msgstr "The exact address of the device installation"

#: src/containers/Migrations/Migrations.tsx:2900
msgid "Транзакции"
msgstr "Transactions"

#: src/components/Stats/TrendsLegend.tsx:22
msgid "Тренд"
msgstr "Trend"

#: src/features/serviceNotification/ServiceNotification.tsx:21
msgid "Уведомление о проведении сервисных работ"
msgstr "Notification of service work"

#: src/containers/Migrations/Migrations.tsx:1231
msgid "Удаление временных файлов"
msgstr "Deleting temporary files"

#: src/containers/Migrations/Migrations.tsx:3515
msgid "Удалено аппаратов: {removedDeviceCount}"
msgstr "Devices removed: {removedDeviceCount}"

#: src/containers/Users/UserMenu.tsx:115
#: src/containers/Terminals/Terminal/TerminalTitle.tsx:88
#: src/containers/Staff/StaffForm.tsx:87
msgid "Удалить"
msgstr "Delete"

#: src/containers/Terminals/Terminal/TerminalTitle.tsx:87
msgid "Удалить аппарат?"
msgstr "Delete the device?"

#: src/containers/Users/UserMenu.tsx:218
msgid "Удалить пользователя"
msgstr "Delete user"

#: src/containers/Users/UserMenu.tsx:114
msgid "Удалить пользователя?"
msgstr "Delete user?"

#: src/containers/Migrations/SystemMigrations.tsx:254
#: src/containers/Migrations/Migrations.tsx:3439
msgid "Удобный формат времени"
msgstr "Convenient time format"

#: src/containers/Migrations/Migrations.tsx:2173
msgid "Уже выполняется миграция другого пользователя"
msgstr "Another user migration is already running"

#: src/containers/Migrations/Migrations.tsx:2094
msgid "Уже выполняется оценка другого пользователя. Дождитесь её завершения."
msgstr "Another user estimation is already running. Wait for it to finish."

#: src/containers/Terminals/EditDevice/MainboardFields/options.ts:117
msgid "УЗ датчик"
msgstr "Ultrasonic sensor"

#. placeholder {0}: formatMoney(price * MAX_INCOME_LIMIT, currency)
#: src/containers/Sales/DeviceIncome.tsx:96
msgid "Укажите сумму для пополнения баланса на выбранном аппарате для покупки воды. Максимальная сумма пополнения - {0}"
msgstr "Specify the amount to replenish the balance on the selected water purchase device. The maximum deposit amount is {0}"

#: src/containers/Migrations/Migrations.tsx:3109
msgid "Управление процессами"
msgstr "Process control"

#: src/containers/Terminals/Terminal/DeviceState/TerminalSummary.tsx:101
msgid "Уровень сигнала"
msgstr "Signal level"

#: src/containers/Dashboard/BillingStats/columns.tsx:38
#: src/containers/Dashboard/BillingStats/BillingLogs.tsx:15
msgid "Услуга"
msgstr "Service"

#: src/config/menu.tsx:72
msgid "Услуги"
msgstr "Services"

#: src/containers/Dashboard/BillingStats/columns.tsx:63
msgid "Успешно обработано"
msgstr "Processed success"

#: src/containers/Terminals/Terminal/DeviceState/TerminalSummary.tsx:53
msgid "Устройство включено"
msgstr "The device is turned on"

#: src/containers/Terminals/Terminal/Device.tsx:84
msgid "Устройство заблокировано из-за не хватки средств"
msgstr "Device is blocked due to insufficient funds"

#: src/containers/Terminals/Terminal/DeviceState/TerminalSummary.tsx:57
#: src/containers/Terminals/Terminal/DeviceState/MeterValue.tsx:65
msgid "Устройство обновлено"
msgstr "The device is updated on"

#: src/containers/Migrations/Migrations.tsx:2822
msgid "Утилизация CPU pod"
msgstr "Pod CPU utilization"

#: src/containers/DeviceList/columns/desktop.tsx:102
msgid "УФ лампа"
msgstr "UV lamp"

#: src/locales/constants.ts:47
msgid "Фамилия"
msgstr "Surname"

#: src/containers/Migrations/Migrations.tsx:2941
msgid "Физическая запись"
msgstr "Physical write"

#: src/containers/Migrations/Migrations.tsx:2933
msgid "Физическое чтение"
msgstr "Physical read"

#: src/containers/Migrations/Migrations.tsx:3621
msgid "Фильтр по выбранным пользователям не установлен"
msgstr "Selected users filter is not set"

#: src/containers/Migrations/Migrations.tsx:3620
msgid "Фильтр по выбранным пользователям: {deviceOwnerFilterCount}"
msgstr "Selected users filter: {deviceOwnerFilterCount}"

#: src/containers/DeviceList/constants.ts:24
msgid "Фильтры"
msgstr "Filters"

#: src/containers/Migrations/Migrations.tsx:3583
msgid "Фин. настройки Oracle"
msgstr "Oracle financial settings"

#: src/containers/Migrations/Migrations.tsx:2598
msgid "Финансовые настройки Oracle"
msgstr "Oracle financial settings"

#: src/containers/Terminals/Terminal/DeviceState/DeviceState.tsx:54
msgid "Финансы"
msgstr "Finance"

#: src/containers/Dashboard/AllMoney/AllMoney.tsx:104
msgid "Финансы - поступления"
msgstr "Finance - income"

#: src/containers/Dashboard/AllMoney/AllMoney.tsx:112
msgid "Финансы - списания"
msgstr "Finance - write-offs"

#: src/containers/Terminals/Terminal/Device.tsx:117
#: src/containers/Terminals/EditDevice/EditDeviceTabTitle.tsx:25
msgid "Фискализация"
msgstr "Fiscalization"

#: src/containers/Migrations/Migrations.tsx:2596
#: src/containers/Migrations/Migrations.tsx:3567
msgid "Фискальные настройки"
msgstr "Fiscal settings"

#: src/containers/Migrations/Migrations.tsx:2866
msgid "Целевая нагрузка"
msgstr "Target load"

#: src/containers/Terminals/Terminal/DeviceState/TerminalFinState.tsx:79
msgid "Цена 1 литра по банковской карте"
msgstr "Price per liter by using IC card"

#: src/containers/Terminals/EditDevice/MainboardFields/BottlerFields.tsx:16
msgid "Цена бутылки, {currencySign}"
msgstr "Bottle price, {currencySign}"

#: src/locales/constants.ts:8
#: src/containers/Terminals/Terminal/DeviceState/TerminalFinState.tsx:67
msgid "Цена за литр"
msgstr "Price per liter"

#: src/locales/constants.ts:10
#: src/containers/Terminals/Terminal/DeviceState/TerminalFinState.tsx:86
msgid "Цена за литр минеральной воды"
msgstr "Price per liter of mineral water"

#: src/locales/constants.ts:9
#: src/containers/Terminals/Terminal/DeviceState/TerminalFinState.tsx:72
msgid "Цена за литр по IC карте"
msgstr "Price per liter by IC card"

#: src/locales/constants.ts:27
#: src/containers/Migrations/formatDuration.tsx:18
msgid "ч"
msgstr "h"

#: src/components/Stats/constants.ts:10
msgid "Час"
msgstr "Hour"

#: src/locales/constants.ts:13
msgid "Часовой пояс"
msgstr "Time zone"

#: src/containers/Omnidesk/OmniChat.tsx:44
msgid "Чат"
msgstr "Chat"

#: src/containers/Terminals/EditDevice/MainboardFields/options.ts:102
msgid "четырехстрочный"
msgstr "four line"

#: src/containers/Terminals/EditDevice/MainboardFields/options.ts:106
msgid "четырехстрочный с десятыми долями баланса"
msgstr "four line with tenths of the balance"

#: src/containers/Migrations/Migrations.tsx:2907
msgid "Чтение строк"
msgstr "Rows read"

#: src/containers/Terminals/Terminal/DeviceState/MeterValue.tsx:70
#: src/components/EditAuditComment/EditAuditCommentModal.tsx:60
#: src/components/ConnectBot/ConnectMaxBot.tsx:174
#: src/components/ConnectBot/ConnectBot.tsx:184
#: src/components/CartridgeValue/EditValueModal.tsx:96
msgid "Что-то пошло не так"
msgstr "Something went wrong"

#: src/locales/constants.ts:21
msgid "Широта"
msgstr "Latitude"

#: src/config/menu.tsx:93
#: src/config/menu.tsx:99
msgid "Школа вендора"
msgstr "Vendor school"

#: src/components/LastServiceDate/LastServiceDate.tsx:149
msgid "Это действие изменит дату обслуживания для ВСХ аппаратов в вашем личном кабинете! Вы уверены?"
msgstr "This action will change the service date for ALL devices in your personal account! Are you sure?"

#: src/components/CartridgeValue/EditValueModal.tsx:154
msgid "Я поменял счётчик ХВС"
msgstr "I replaced the cold water counter"
